<script>
import api from "@/helpers/api-rest/api.js";
import { methods } from "@/methods/methods-essay";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import ValidatedMultiselect from "@/components/forms/validated-multiselect.vue";
import CenterModal from "@/components/modals/center-modal.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import AppTextareaAi from "@/components/forms/AppTextareaAi.vue";
import store from "@/state/store";
import Swal from "sweetalert2";
import qs from "qs";
import { required, numeric, helpers, email } from "vuelidate/lib/validators";
import { errorMessages } from "@/helpers/validations/errorMessages";
import { notifyValidationFailedAndFocusFirstInvalid } from "@/helpers/validations/vuelidateFormFeedback";
import { mapState } from "vuex";

// const decimalRegex = helpers.regex('decimal', /^-?\d+(\.\d+)?$/);
// Validador: Detecta si contiene comas o apóstrofes (separadores incorrectos)
const noCommasOrApostrophes = helpers.regex(
  "noCommasOrApostrophes",
  /^[^,']*$/
);

// Validador: Solo caracteres numéricos y puntos
const noInvalidCharacters = helpers.regex("noInvalidCharacters", /^[0-9.]*$/);

// Validador: Número entero o decimal con punto
const validDecimal = helpers.regex("validDecimal", /^-?\d*(\.\d+)?$/);

// const noSpecialChars = helpers.regex("noSpecialChars", /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]*$/);
// const noSpaces = helpers.regex("noSpaces", /^\S*$/);
const onlyLetters = helpers.regex("onlyLetters", /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/);

const validDateFormat = helpers.withParams(
  { type: "validDateFormat" },
  (value) => {
    if (!value) return false; // Permitir vacío
    const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
    return regex.test(value);
  }
);

const validEndDate = helpers.withParams(
  { type: "validEndDate" },
  (value, parentVm) => {
    // `parentVm` es el contexto del elemento actual (action)
    if (!value || !parentVm.init_date) return true; // Permitir vacío o si no hay `init_date`
    const startDate = new Date(parentVm.init_date);
    const endDate = new Date(value);
    return endDate >= startDate; // `end_date` debe ser mayor o igual que `init_date`
  }
);

const currentDate = new Date().toISOString().slice(0, 10);

// const isPdf = (value) => {
//   return value.endsWith(".pdf"); // Comprueba que el nombre termine en .pdf
// };

const isPdf = (value) => {
  // If value is empty, null or undefined, validation passes (field is optional)
  if (!value || value === "" || value === null || value === undefined) {
    return true;
  }
  // Only validate PDF format when a value is present
  return typeof value === "string" && value.toLowerCase().endsWith(".pdf");
};

export default {
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    ValidatedMultiselect,
    CenterModal,
    LoadingOverlay,
    AppTextareaAi,
  },
  props: {
    id: { type: String, default: "ModalEssay" },

    essay: {
      type: Object,
      default: () => {
        return {
          id: null,
          name: "",
          description: "",
          antecedentes: "",
          arte_status: "",
          type: null,
          primary_project_id: null,
          course_ids: [],
          courses: [],
          strategic_lines: [],
          project_phases: "",
          essay_coordinator: {
            center_id: null,
            essay_professorates: [],
            document_name: "",
            selection_adequacy: "",
          },
          targets: [
            {
              title: "",
              description: "",
              target_results: [
                {
                  id: "",
                  target_id: "",
                  title: "",
                  description: "",
                  quantitative_qualitative_assessment: "",
                  products_realized: "",
                  educational_community_impact: "",
                  transferability_to_other_centers: "",
                  other_expected_results: "",
                  communications_conferences: "",
                  exploitation_licenses_patents: "",
                  agreements_networks_proposals: "",
                },
              ],
              // target_achievements: []
            },
          ],
          actions: [
            {
              id: "",
              name: "",
              descriptions: "",
              init_date: currentDate,
              end_date: currentDate,
              responsables: "",
              center_company_responsable: "",
              responsible_type: null,
              responsible_id: null,
              risks: "",
              contingency_plan: "",
              education_activities: [],
              economic_forecats: [],
            },
          ],
          essay_center_partner: [
            {
              selection_adequacy: "",
              essay_professorates: [],
              courses: [],
            },
          ],
        };
      },
    },
    isActive: Boolean,
    currentStep: { type: Number, default: 0 },
    project_id: null,
  },
  data() {
    return {
      file: null,
      fileName: "",
      filePartnerCompanyname: "",
      selectOptionsCenterType: [],
      modalStatus: this.isActive,
      tableFields: [
        { key: "description", sortable: false, label: "Descripción" },
        { key: "createdBy", sortable: false, label: "Usuario" },
      ],
      isClosing: false,
      targets: [],
      targetResults: [],
      isCollapseOpen: false,
      collapseOpen: [],
      selectOptionsCenterCoordinators: [],
      selectOptionsStrategicLines: [],
      selectOptionsPrimaryProjects: [],
      selectedCoordinator: "",
      project: this.project_id,
      finished: false,
      loading: false,
      intervalId: null,
      ending: false,
      // errorMessages: [],
      progress: 0,
      interval: null,
      errorMessages,
      draftAction: false,
      isSaving: false,
      justSavedInValidate: false,
      coordinatorCenter: null,
      partnerCenters: {}, // Store partner center data by index
      // Simple state for CenterModal
      modalCenterId: null, // ID of center being edited (null for new)
      modalCenterTypeId: 1, // 1 = coordinator, 2 = partner
      modalPartnerIndex: null, // Index of partner center (null for coordinator)
      ageRangeOptions: [
        { value: '0-17', label: '0-17' },
        { value: '18-29', label: '18-29' },
        { value: '30-54', label: '30-54' },
        { value: '55-plus', label: '55 y más' }
      ],
      genderOptions: [
        { value: 'male', label: 'Hombre' },
        { value: 'female', label: 'Mujer' },
        { value: 'other', label: 'Otro' },
      ],
    };
  },
  computed: {
    ...mapState("loading", {
      globalLoading: (state) => state.loading,
    }),
    userName() {
      return store.getters["auth/nameUser"];
    },
    creationDate() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Los meses comienzan desde 0
      const year = today.getFullYear();
      return `${day}/${month}/${year}`;
    },
    modalTitle() {
      return this.essay?.id ? "Editar redacción" : "Añadir redacción";
    },
    submitButtonText() {
      return this.essay?.id ? "Save" : "Add Center";
    },
    fileInputLabel() {
      return this.fileName
        ? this.fileName
        : this.essay.essay_coordinator.document_name
        ? this.essay.essay_coordinator.document_name
        : "Selecciona archivo...";
    },
    validCurrentStep() {
      // Ensure currentStep is always a valid number between 0 and 3
      const step = this.currentStep;
      if (step === null || step === undefined || isNaN(step)) {
        return 0;
      }
      const numStep = Number(step);
      // Clamp between 0 and 3 (valid step indices)
      return Math.max(0, Math.min(3, numStep));
    },
    saveSpinnerMessage() {
      if (this.ending) {
        return "Finalizando...";
      }
      if (this.globalLoading || this.isSaving || this.loading) {
        return "Guardando...";
      }
      return "";
    },
    // Computed props for the single CenterModal instance
    centerModalProps() {
      return {
        essay_id: this.essay?.id,
        center_type_id: this.modalCenterTypeId,
        id: this.modalCenterId,
      };
    },
    actionCenterOptions() {
      return (this.essay?.centers || []).map((center) => ({
        id: center.id,
        name: center.name,
        type: "center",
        value: `center:${center.id}`,
      }));
    },
    actionCompanyOptions() {
      const partners = (this.essay?.partner_companies || []).map((company) => ({
        id: company.id,
        name: company.name,
        type: "company",
        value: `company:${company.id}`,
      }));
      const accessions = (this.essay?.accession_company_partner || [])
        .filter((company) => company.status === "aceptada")
        .map((company) => ({
          id: company.id,
          name: company.name,
          type: "accession_company",
          value: `accession_company:${company.id}`,
        }));

      return [...partners, ...accessions];
    },
  },
  created() {
    this.loadSelectOptionsCenterCoordinators();
  },
  methods: {
    addRowProfessorate: methods.addRowProfessorate,
    deleteRowProfessorate: methods.deleteRowProfessorate,
    addRowPartner: methods.addRowPartner,
    addRowResults: methods.addRowResults,
    addRowAction: methods.addRowAction,
    addRowCourse: methods.addRowCourse,
    deleteRowCourse: methods.deleteRowCourse,
    addRowActivity: methods.addRowActivity,
    addRow: methods.addRow,
    deleteRowPartner: methods.deleteRowPartner,
    deleteRowAction: methods.deleteRowAction,
    deleteRowActionActivity: methods.deleteRowActionActivity,
    addRowCenterPartner: methods.addRowCenterPartner,
    deleteCenterPartner: methods.deleteCenterPartner,
    addRowForecast: methods.addRowForecast,
    deleteRowActionForecast: methods.deleteRowActionForecast,
    addRowProfessoratePartner: methods.addRowProfessoratePartner,
    deleteRowProfessoratePartner: methods.deleteRowProfessoratePartner,
    addRowAchievement: methods.addRowAchievement,
    deleteRowTargetAchievement: methods.deleteRowTargetAchievement,
    addRowResultAchievement: methods.addRowResultAchievement,
    deleteRowResultAchievement: methods.deleteRowResultAchievement,
    getResponsibleGroup(action) {
      if (action._responsible_group) {
        return action._responsible_group;
      }
      if (action.responsible_type === "center") {
        return "center";
      }
      if (["company", "accession_company"].includes(action.responsible_type)) {
        return "company";
      }
      return null;
    },
    setResponsibleGroup(action, group) {
      const previousGroup = this.getResponsibleGroup(action);
      this.$set(action, "_responsible_group", group);
      if (previousGroup && previousGroup !== group) {
        action.responsible_type = null;
        action.responsible_id = null;
      }
    },
    getResponsibleSelectValue(action) {
      if (!action.responsible_type || !action.responsible_id) {
        return "";
      }
      return `${action.responsible_type}:${action.responsible_id}`;
    },
    setResponsibleSelectValue(action, value) {
      if (!value) {
        action.responsible_type = null;
        action.responsible_id = null;
        return;
      }
      const [type, id] = value.split(":");
      action.responsible_type = type;
      action.responsible_id = Number.parseInt(id, 10);
      this.$set(
        action,
        "_responsible_group",
        type === "center" ? "center" : "company"
      );
    },
    // validateEndDate: methods.validateEndDate,
    loadSelectOptionsCenterCoordinators() {
      const apiEndpoint = `/api/v1/centers`;
      api
        .get({ url: apiEndpoint })
        .then((response) => {
          this.selectOptionsCenterCoordinators = response?.data?.data;
        })
        .catch((error) => {
          console.error("Error al cargar la lista:", error);
        });
    },
    formatDate(d = new Date()) {
      return `${String(d.getDate()).padStart(2, "0")}${String(
        d.getMonth() + 1
      ).padStart(2, "0")}${d.getFullYear()}${String(d.getHours()).padStart(
        2,
        "0"
      )}${String(d.getMinutes()).padStart(2, "0")}`;
    },
    /**
     * Sanitizes numeric input to only allow positive integers
     * @param {Event} event - Input event
     * @param {string} fieldName - Name of the field to update
     */
    sanitizeNumericInput(event, fieldName) {
      const input = event.target;
      // Remove any non-numeric characters
      const numericValue = input.value.replace(/\D/g, '');
      
      // Update the model with sanitized value
      const parsedValue = numericValue === '' ? null : Number.parseInt(numericValue, 10);
      this.$set(this.essay, fieldName, parsedValue);
      
      // Update the input value to reflect the sanitized value
      this.$nextTick(() => {
        if (input.value !== numericValue) {
          input.value = numericValue;
        }
      });
    },
    loadSelectOptionsStrategicLines() {
      const apiEndpoint = `/api/v1/strategic-lines`;
      api
        .get({ url: apiEndpoint, params: {project_id: this.project_id} })
        .then((response) => {
          this.selectOptionsStrategicLines = response.data.data.map((line) => ({
            id: line.id,
            description: line.description,
          }));
        })
        .catch((error) => {
          console.error("Error al cargar la lista:", error);
        });
    },
    loadPartnerCenter(index) {
      const center = this.essay?.essay_center_partner?.[index];
      const centerId = center?.center_id;
      if (!centerId) {
        this.$set(this.partnerCenters, index, null);
        return;
      }
      
      const apiEndpoint = `/api/v1/centers/${centerId}`;
      api
        .get({ url: apiEndpoint })
        .then((response) => {
          this.$set(this.partnerCenters, index, response?.data?.data);
        })
        .catch((error) => {
          console.error("Error loading partner center:", error);
          this.$set(this.partnerCenters, index, null);
        });
    },
    toggleCollapse(index) {
      // console.log(this.collapseOpen, index);
      this.$set(this.collapseOpen, index, !this.collapseOpen[index]);
    },
    deleteRowTarget(key) {
      if (this.essay?.targets?.length <= 1) {
        Swal.fire({
          title: "No se puede borrar",
          text: "Debe haber al menos un objetivo.",
          icon: "warning",
          confirmButtonColor: "#34c38f",
          confirmButtonText: "Aceptar",
        });
        return;
      }
      Swal.fire({
        title: "¿Estás seguro?",
        text: "Una vez eliminado no podrá recuperarlo",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Sí, borrar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.essay.targets.splice(key, 1);
        }
      });
    },
    deleteRowTargetResult(index, key) {
      if (this.essay?.targets[index]?.target_results?.length <= 1) {
        Swal.fire({
          title: "No se puede borrar",
          text: "Debe haber al menos un resultado.",
          icon: "warning",
          confirmButtonColor: "#34c38f",
          confirmButtonText: "Aceptar",
        });
        return;
      }
      Swal.fire({
        title: "¿Estás seguro?",
        text: "Una vez eliminado no podrá recuperarlo",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Sí, borrar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.essay.targets[index].target_results.splice(key, 1);
        }
      });
    },
    handleCloseStart() {
      this.isClosing = true;
    },
    handleModalClose() {
      console.log("Cerrando modal");
      this.$v.$reset();
      this.isClosing = false;
      this.isSaving = false;
      this.draftAction = false;
      this.justSavedInValidate = false;
      this.$emit("close");
    },
    /**
     * Handler for "Finalizar" button - validates entire form and finalizes
     */
    async finishStep() {
      this.draftAction = false;

      // Validate all steps before finalizing
      const allStepsValid = [0, 1, 2].every((stepIndex) => {
        const isValid = this.validateStep("finish", stepIndex);
        if (!isValid) {
          console.warn(`Step ${stepIndex} validation failed`);
        }
        return isValid;
      });

      if (!allStepsValid) {
        notifyValidationFailedAndFocusFirstInvalid(this);
        return;
      }

      Swal.fire({
        title: "¿Estás seguro?",
        text: "Una vez finalizado no podrá editarlo",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Sí, finalizar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.essay.finished = true;
          this.ending = true;
          this.progress = 0;
          this.fakeProgress();
          this.saveCurrentStep(3);
        }
      });
    },
    handleNextStep(currentTabIndex, nextTabIndex) {
      console.log("handleNextStep", currentTabIndex, nextTabIndex);
      // Update essay.current_step when step changes (forward or backward)
      // This ensures the step is saved correctly when user goes back and saves
      this.essay.current_step = nextTabIndex;

      // Don't save if handleValidate already saved in this cycle
      if (this.justSavedInValidate) {
        this.justSavedInValidate = false;
        return;
      }

      // Don't save if already saving (handleValidate already saved)
      // Only save step change if essay exists, not closing, and not currently saving
      if (!this.isClosing && !this.isSaving && this.essay?.id && !this.draftAction) {
        // Save step change in background (don't wait for it)
        // This is only for when user navigates back/forward without using "Guardar y continuar"
        this.saveCurrentStep(nextTabIndex).catch((error) => {
          // Silently fail - step change save is not critical
          console.error("Error saving step change:", error);
        });
      }
    },
    saveEssay() {
      this.essay.finished = false;
      if (this.essay?.id) {
        return this.updateEssay()
          .then(() => {
            // Close modal only when draftAction is true (Guardar button)
            // When draftAction is false (Guardar y continuar), don't close, just advance step
            if (this.draftAction) {
              this.isSaving = false;
              this.handleModalClose();
            } else {
              this.isSaving = false;
            }
          })
          .catch((error) => {
            // Error already handled in updateEssay
            this.isSaving = false;
            throw error;
          });
      } else {
        return this.createEssay()
          .then(() => {
            // Close modal only when draftAction is true (Guardar button)
            // When draftAction is false (Guardar y continuar), don't close, just advance step
            if (this.draftAction) {
              this.isSaving = false;
              this.handleModalClose();
            } else {
              this.isSaving = false;
            }
          })
          .catch((error) => {
            // Error already handled in createEssay
            this.isSaving = false;
            throw error;
          });
      }
    },
    saveCurrentStep(stepNumber) {
      if (this.draftAction) return this.saveEssay();

      // Preserve previous state to allow rollback on backend error
      const previousStep = this.essay.current_step;
      const previousFinished = this.essay.finished;
      const previousStatusId = this.essay.essay_status_id;

      this.essay.current_step = stepNumber;
      this.essay.finished = this.essay.current_step === 3 ? true : false;
      if (stepNumber == 3) {
        // Cambiar el estado a "En proceso" anteriomente se pasaba a revision(essay_status_id = 2)
        this.essay.essay_status_id = 5;
      }

      const handleStepSaveError = (error) => {
        // Rollback optimistic changes if backend fails
        this.isSaving = false;
        this.essay.current_step = previousStep;
        this.essay.finished = previousFinished;
        this.essay.essay_status_id = previousStatusId;
        throw error;
      };

      if (this.essay?.id) {
        return this.updateEssay()
          .then((response) => {
            this.isSaving = false;
            return response;
          })
          .catch(handleStepSaveError);
      } else {
        return this.createEssay()
          .then((response) => {
            this.isSaving = false;
            return response;
          })
          .catch(handleStepSaveError);
      }
    },
    onFilePartnerCompanyChange(event, partner, index) {
      this.file = event.target.files[0];
      const validationPath = this.$v.essay.partner_companies?.$each?.[index];

      if (this.file.type !== "application/pdf") {
        validationPath.document_name.$touch();
        return;
      }

      validationPath.document_name.$reset();

      partner.document_name = this.formatDate() + "-" + this.file.name;
      this.uploadFilePartnerCompany(this.file)
        .then((response) => {
          const file = response?.data?.data;
          partner.document_path = file.path;
        })
        .catch((error) => {
          console.error("Error al cargar el archivo:", error);
        });
    },
    onFileCoordinatorChange(event) {
      this.file = event.target.files[0];

      if (this.file.type !== "application/pdf") {
        this.essay.essay_coordinator.document_name = "";
        this.$v.essay.essay_coordinator.document_name.$touch();
        return;
      }

      this.$v.essay.essay_coordinator.document_name.$reset();

      this.fileName = this.formatDate() + "-" + this.file.name;
      this.essay.essay_coordinator.document_name =
        this.formatDate() + "-" + this.file.name;

      this.uploadFileCoordinator(this.file)
        .then((response) => {
          const file = response?.data?.data;
          this.essay.essay_coordinator.document_path = file.path;
        })
        .catch((error) => {
          console.error("Error al cargar el archivo:", error);
        });
    },
    onFilePartnerChange(event, center, index) {
      this.file = event.target.files[0];
      const validationPath = this.$v.essay.essay_center_partner?.$each?.[index];

      if (this.file.type !== "application/pdf") {
        validationPath.document_name.$touch();
        return;
      }

      validationPath.document_name.$reset();
      center.document_name = this.formatDate() + "-" + this.file.name;

      this.uploadFilePartner(this.file)
        .then((response) => {
          const file = response?.data?.data;
          center.document_path = file.path;
          console.log(center);
        })
        .catch((error) => {
          console.error("Error al crear el centro:", error);
        });
    },
    uploadFileCoordinator(file) {
      const formData = new FormData();
      formData.set("file", file);
      formData.append("path", "coordinators");
      const config = { headers: { "content-type": "multipart/form-data" } };

      // this.essay.essay_coordinator.document_name = file.name;

      const apiEndpoint = `/api/v1/upload-file`;
      return api
        .post({ url: apiEndpoint, data: formData, config })
        .catch((error) => {
          this.loading = false;
          console.error("Error upload file:", error);

          // Extract error message from response
          const errorMessage =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "Error al subir el archivo. Por favor, inténtelo de nuevo.";

          Swal.fire({
            icon: "error",
            title: "Error al subir el archivo",
            html: errorMessage,
            confirmButtonColor: "#34c38f",
            confirmButtonText: "Aceptar",
          });
        });
    },
    uploadFilePartner(file) {
      const formData = new FormData();
      formData.set("file", file);
      formData.append("path", "partners");
      const config = { headers: { "content-type": "multipart/form-data" } };

      const apiEndpoint = `/api/v1/upload-file`;
      return api
        .post({ url: apiEndpoint, data: formData, config })
        .catch((error) => {
          this.loading = false;
          console.error("Error upload file:", error);

          // Extract error message from response
          const errorMessage =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "Error al subir el archivo. Por favor, inténtelo de nuevo.";

          Swal.fire({
            icon: "error",
            title: "Error al subir el archivo",
            html: errorMessage,
            confirmButtonColor: "#34c38f",
            confirmButtonText: "Aceptar",
          });
        });
    },
    uploadFilePartnerCompany(file) {
      const formData = new FormData();
      formData.set("file", file);
      formData.append("path", "companies");
      const config = { headers: { "content-type": "multipart/form-data" } };

      const apiEndpoint = `/api/v1/upload-file`;
      return api
        .post({ url: apiEndpoint, data: formData, config })
        .catch((error) => {
          this.loading = false;
          console.error("Error upload file:", error);

          // Extract error message from response
          const errorMessage =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "Error al subir el archivo. Por favor, inténtelo de nuevo.";

          Swal.fire({
            icon: "error",
            title: "Error al subir el archivo",
            html: errorMessage,
            confirmButtonColor: "#34c38f",
            confirmButtonText: "Aceptar",
          });
        });
    },
    createEssay() {
      this.loading = true;
      const apiEndpoint = `/api/v1/essays`;
      this.essay.project_id = this.project_id;
      this.essay.essay_status_id = 1;
      return api
        .post({ url: apiEndpoint, data: this.essay })
        .then((response) => {
          this.loading = false;
          const newEssay = response?.data?.data;
          if (!newEssay.essay_coordinator) {
            newEssay.essay_coordinator = {
              center_id: null,
              document_name: "",
              document_path: "",
              essay_professorates: [],
            };
          }
          this.$emit("updatedEssay", newEssay);
          return response;
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error al crear el essay:", error);

          // Extract error message from response
          const errorMessage =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "Error al crear el proyecto. Por favor, inténtelo de nuevo.";

          Swal.fire({
            icon: "error",
            title: "Error al crear el proyecto",
            html: errorMessage,
            confirmButtonColor: "#34c38f",
            confirmButtonText: "Aceptar",
          });

          // Re-throw error to prevent modal from closing
          throw error;
        });
    },
    updateEssay() {
      this.loading = true;
      const apiEndpoint = `/api/v1/essays`;
      return api
        .put({ url: apiEndpoint, data: this.essay, id: this.essay.id })
        .then((response) => {
          this.progress = 100;
          clearInterval(this.interval);
          this.loading = false;
          this.ending = false;
          const updatedEssay = response?.data?.data;
          if (!updatedEssay.essay_coordinator) {
            updatedEssay.essay_coordinator = {
              center_id: null,
              document_name: "",
              document_path: "",
              essay_professorates: [],
            };
          }
          console.log(updatedEssay);
          this.$emit("updatedEssay", updatedEssay);

          if (this.essay.finished === true) {
            this.handleModalClose();
            this.successmsg(updatedEssay.url, updatedEssay);
          }
          return response;
        })
        .catch((error) => {
          this.progress = 100; // También completa si hay error
          clearInterval(this.interval);
          this.loading = false;
          this.ending = false;
          console.error("Error al guardar el essay:", error);

          // Re-throw error to prevent modal from closing
          throw error;
        });
    },
    submitForm() {
      console.log(this.essay.current_step);
      // if (this.essay?.id) {
      //   return this.updateEssay();
      // }
      // return this.createEssay();
    },
    loadTargetResults() {
      this.targets.forEach((target) => {
        const apiEndpoint = `/api/v1/target-results?target_id=${target.id}`;
        api
          .get({ url: apiEndpoint })
          .then((response) => {
            this.targetResults.push(...response?.data?.data);
            // console.log("Array2: ", this.targetResults);
          })
          .catch((error) => {
            console.error("Error loading data:", error);
          });
      });
    },
    loadTargets() {
      const apiEndpoint = `/api/v1/targets?essay_id=${this.essay?.id}`;
      api
        .get({ url: apiEndpoint })
        .then((response) => {
          this.targets = response?.data?.data;
        })
        .catch((error) => {
          console.error("Error loading data:", error);
        });
    },
    loadData() {
      this.isSaving = false;
      this.draftAction = false;
      this.justSavedInValidate = false;
      this.loadTargets();
      this.loadTargetResults();
      this.loadSelectOptionsStrategicLines();
      this.loadCoordinatorCenter();
      this.loadProject();
      // Load partner center data
      if (this.essay?.essay_center_partner?.length) {
        this.essay.essay_center_partner.forEach((partner, index) => {
          this.loadPartnerCenter(index);
        });
      }
      console.log("Fecha actual", this.currentDate);
    },
    loadProject() {
      if (!this.project_id) {
        this.selectOptionsPrimaryProjects = [];
        return;
      }
      
      const apiEndpoint = `/api/v1/projects/${this.project_id}`;
      api
        .get({ url: apiEndpoint })
        .then((response) => {
          const projectData = response?.data?.data;
          if (projectData?.primary_projects) {
            this.selectOptionsPrimaryProjects = projectData.primary_projects.map((project) => ({
              id: project.id,
              name: project.name || project.description || `Proyecto ${project.id}`,
            }));
          } else {
            this.selectOptionsPrimaryProjects = [];
          }
        })
        .catch((error) => {
          console.error("Error loading project data:", error);
          this.selectOptionsPrimaryProjects = [];
        });
    },
    loadCoordinatorCenter() {
      const centerId = this.essay?.essay_coordinator?.center_id;
      if (!centerId) {
        this.coordinatorCenter = null;
        return;
      }
      
      const apiEndpoint = `/api/v1/centers/${centerId}`;
      api
        .get({ url: apiEndpoint })
        .then((response) => {
          this.coordinatorCenter = response?.data?.data;
        })
        .catch((error) => {
          console.error("Error loading coordinator center:", error);
          this.coordinatorCenter = null;
        });
    },
    openCenterModal() {
      // Set state for coordinator center
      const centerId = this.essay?.essay_coordinator?.center_id || 
                       (this.coordinatorCenter && this.coordinatorCenter.id) || 
                       null;
      this.modalCenterId = centerId;
      this.modalCenterTypeId = 1;
      this.modalPartnerIndex = null;
      this.$bvModal.show("ModalCenter");
    },
    openPartnerCenterModal(index) {
      // Set state for partner center
      const partner = this.essay?.essay_center_partner?.[index];
      const centerId = partner?.center_id || 
                       (this.partnerCenters[index] && this.partnerCenters[index].id) || 
                       null;
      this.modalCenterId = centerId;
      this.modalCenterTypeId = 2;
      this.modalPartnerIndex = index;
      this.$bvModal.show("ModalCenter");
    },
    handleCenterSuccess(center) {
      // Handle success based on modal state
      if (this.modalCenterTypeId === 1) {
        // Coordinator center
        this.essay.essay_coordinator.center_id = center.id;
        this.coordinatorCenter = center;
      } else if (this.modalCenterTypeId === 2 && this.modalPartnerIndex !== null) {
        // Partner center
        this.essay.essay_center_partner[this.modalPartnerIndex].center_id = center.id;
        this.$set(this.partnerCenters, this.modalPartnerIndex, center);
      }
      // Reset modal state
      this.modalCenterId = null;
      this.modalCenterTypeId = 1;
      this.modalPartnerIndex = null;
    },
    successmsg(url, essay) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "!Buen trabajo!",
          html: `
          <div style="position: relative;">
            <p>Tu proyecto ha sido registrado correctamente.<br><br></p>
            <iframe src="${url}" frameborder="0" style="height: 70vh; width: 100%;"></iframe>
          </div>
        `,
          icon: "success",
          width: 1000,
          padding: 20,
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.close();
            // Redirect to essay detail page
            if (essay && essay.id && essay.project_id) {
              this.$router.push({
                name: 'essay-detail',
                params: {
                  id: essay.project_id,
                  essayId: essay.id,
                },
              });
            }
          }
        });
    },

    downloadFileAnexo(num, params) {
      const queryString = qs.stringify(params);
      const baseUrl = process.env.VUE_APP_API_HOST;
      const url = `${baseUrl}/anexo${num}?${queryString}`;
      window.open(url, "_blank");
    },

    downloadFileAnexoICollaborator(essay_center_partner) {
      const params = {
        center_id: essay_center_partner?.center_id,
        essay_id: this.essay?.id,
        essay_professorates: essay_center_partner?.essay_professorates,
      };
      console.log(params);

      this.downloadFileAnexo(1, params);
    },
    downloadFileAnexoII(name, responsable, cif) {
      const params = {
        partner_name: name,
        partner_responsable: responsable,
        partner_cif: cif,
        essay_id: this.essay?.id,
        center_id: this.essay?.essay_coordinator?.center_id,
      };
      console.log(params);

      this.downloadFileAnexo(2, params);
    },
    downloadFileAnexoI() {
      const params = {
        center_id: this.essay?.essay_coordinator?.center_id,
        essay_id: this.essay?.id,
        essay_professorates: this.essay?.essay_coordinator?.essay_professorates,
      };
      this.downloadFileAnexo(1, params);
    },
    downloadFileAnexoIII() {
      const params = {
        center_id: this.essay?.essay_coordinator?.center_id,
        essay_id: this.essay?.id,
        essay_center_partner_ids:
          this.essay?.essay_center_partner?.map(
            (partner) => partner.center_id
          ) || [],
      };
      this.downloadFileAnexo(3, params);
    },
    // Validate targets without result_achievements and target_achievements
    // Used in step 0 validation since these fields are filled in step 2
    validateTargetsWithoutAchievements() {
      if (!this.essay.targets || !this.essay.targets.length) {
        return false;
      }

      if (!this.$v.essay.targets || !this.$v.essay.targets.$each) {
        return false;
      }

      return this.essay.targets.some((target, i) => {
        const targetValidation = this.$v.essay.targets.$each[i];
        let targetHasError = false;
        if (!targetValidation) {
          return false;
        }

        // Validate title and description
        if (targetValidation.title) {
          targetValidation.title.$touch();
        }
        if (targetValidation.description) {
          targetValidation.description.$touch();
        }
        if (
          (targetValidation.title && targetValidation.title.$invalid) ||
          (targetValidation.description && targetValidation.description.$invalid)
        ) {
          console.log(`Error en targets[${i}].title o description`);
          targetHasError = true;
        }

        // Validate target_results (title, description and new required fields, not result_achievements)
        if (target.target_results && target.target_results.length) {
          if (targetValidation.target_results && targetValidation.target_results.$each) {
            const targetResultsHasError = target.target_results.some((result, j) => {
              const resultValidation = targetValidation.target_results.$each[j];
              if (!resultValidation) {
                return false;
              }
              // Touch all required fields
              if (resultValidation.title) {
                resultValidation.title.$touch();
              }
              if (resultValidation.description) {
                resultValidation.description.$touch();
              }
              if (resultValidation.quantitative_qualitative_assessment) {
                resultValidation.quantitative_qualitative_assessment.$touch();
              }
              if (resultValidation.products_realized) {
                resultValidation.products_realized.$touch();
              }
              if (resultValidation.educational_community_impact) {
                resultValidation.educational_community_impact.$touch();
              }
              if (resultValidation.transferability_to_other_centers) {
                resultValidation.transferability_to_other_centers.$touch();
              }
              // Check if any required field is invalid
              if (
                (resultValidation.title && resultValidation.title.$invalid) ||
                (resultValidation.description && resultValidation.description.$invalid) ||
                (resultValidation.quantitative_qualitative_assessment && resultValidation.quantitative_qualitative_assessment.$invalid) ||
                (resultValidation.products_realized && resultValidation.products_realized.$invalid) ||
                (resultValidation.educational_community_impact && resultValidation.educational_community_impact.$invalid) ||
                (resultValidation.transferability_to_other_centers && resultValidation.transferability_to_other_centers.$invalid)
              ) {
                console.log(`Error en targets[${i}].target_results[${j}]`);
                return true;
              }
              return false;
            });
            if (targetResultsHasError) {
              targetHasError = true;
            }
          }
        }
        console.log("targetHasError", targetHasError);
        return targetHasError;
      });
    },

    /**
     * Centralized validation configuration
     * Defines which fields to validate for each step and validation mode
     */
    getValidationConfig() {
      return {
        0: {
          // Step 0: Información General y Objetivos
          save: {
            // Partial validation for "Guardar" button
            fields: ["name", "type"],
            customValidators: [],
          },
          continue: {
            // Full validation for "Guardar y continuar"
            fields: [
              "name",
              "type",
              "primary_project_id",
              "description",
              "antecedentes",
              "arte_status",
              "strategic_lines",
              "centers_number",
              "companies_number",
              "professorates_number",
              "students_number",
            ],
            customValidators: ["validateTargetsBasic"],
          },
          finish: {
            // Complete validation for "Finalizar"
            fields: [
              "name",
              "type",
              "description",
              "antecedentes",
              "arte_status",
              "strategic_lines",
              "centers_number",
              "companies_number",
              "professorates_number",
              "students_number",
            ],
            customValidators: ["validateTargetsComplete"],
          },
        },
        1: {
          // Step 1: Centros y Empresas
          save: {
            fields: ["essay_coordinator.center_id"],
            customValidators: [],
          },
          continue: {
            fields: [
              "essay_coordinator",
              "essay_coordinator.selection_adequacy",
              "courses",
              "essay_center_partner",
              "partner_companies",
            ],
            customValidators: ["validatePartners", "validateCompanies"],
          },
          finish: {
            fields: [
              "essay_coordinator",
              "courses",
              "essay_center_partner",
              "partner_companies",
            ],
            customValidators: ["validatePartners", "validateCompanies"],
          },
        },
        2: {
          // Step 2: Acciones e Indicadores
          save: {
            fields: [],
            customValidators: ["validateActionsBasic"],
          },
          continue: {
            fields: ["project_phases", "actions"],
            customValidators: ["validateActions", "validateAchievements"],
          },
          finish: {
            fields: ["project_phases", "actions"],
            customValidators: ["validateActions", "validateAchievements"],
          },
        },
      };
    },

    /**
     * Main validation method - centralizes all validation logic
     * @param {string} mode - 'save' | 'continue' | 'finish'
     * @param {number} stepIndex - Current step index
     * @returns {boolean} - true if valid, false otherwise
     */
    validateStep(mode, stepIndex) {
      const config = this.getValidationConfig();
      const stepConfig = config[stepIndex];

      if (!stepConfig || !stepConfig[mode]) {
        console.warn(`No validation config found for step ${stepIndex}, mode ${mode}`);
        return true;
      }

      const validationConfig = stepConfig[mode];

      // Reset validation state first to clear previous validation states
      this.$v.$reset();

      // Validate simple fields using Vuelidate
      if (validationConfig.fields.length > 0) {
        const resolvePath = (obj, path) =>
          path.split(".").reduce((acc, key) => acc?.[key], obj);

        // Touch only the specific fields that need validation
        validationConfig.fields.forEach((field) => {
          const validation = resolvePath(this.$v.essay, field);
          if (validation && validation.$touch) {
            validation.$touch();
          }
        });

        // Check if any field is invalid
        const hasInvalidField = validationConfig.fields.some((field) => {
          const validation = resolvePath(this.$v.essay, field);
          return validation && validation.$invalid;
        });

        if (hasInvalidField) {
          return false;
        }
      }

      // Execute custom validators
      for (const validatorName of validationConfig.customValidators) {
        const isValid = this.executeCustomValidator(validatorName);
        if (!isValid) {
          return false;
        }
      }

      return true;
    },

    /**
     * Executes custom validators by name
     * @param {string} validatorName - Name of the validator to execute
     * @returns {boolean} - true if valid, false otherwise
     */
    executeCustomValidator(validatorName) {
      const validators = {
        validateTargetsBasic: () => {
          // Basic validation: only title and description, no achievements
          return !this.validateTargetsWithoutAchievements();
        },
        validateTargetsComplete: () => {
          // Complete validation: includes achievements
          return this.validateTargetsComplete();
        },
        validatePartners: () => {
          return this.validatePartnerCenters();
        },
        validateCompanies: () => {
          return this.validatePartnerCompanies();
        },
        validateActionsBasic: () => {
          // Basic validation: only name field
          return this.validateActionsBasic();
        },
        validateActions: () => {
          // Full validation: all action fields
          return this.validateActionsComplete();
        },
        validateAchievements: () => {
          return this.validateAllAchievements();
        },
      };

      const validator = validators[validatorName];
      if (!validator) {
        console.warn(`Validator ${validatorName} not found`);
        return true;
      }

      return validator();
    },

    /**
     * Validates partner centers
     */
    validatePartnerCenters() {
      if (!this.essay.essay_center_partner?.length) {
        return true;
      }

      for (let index = 0; index < this.essay.essay_center_partner.length; index++) {
        const partner = this.essay.essay_center_partner[index];
        const partnerValidation = this.$v.essay.essay_center_partner.$each[index];

        // Validate center_id
        if (partnerValidation?.center_id) {
          partnerValidation.center_id.$touch();
          if (partnerValidation.center_id.$invalid) {
            return false;
          }
        }

        // Validate professorates
        if (partner.essay_professorates?.length) {
          for (let j = 0; j < partner.essay_professorates.length; j++) {
            const profValidation = partnerValidation.essay_professorates.$each[j];
            if (profValidation) {
              profValidation.name.$touch();
              profValidation.last_name.$touch();
              profValidation.department.$touch();
              profValidation.dni.$touch();
              profValidation.email.$touch();
              profValidation.gender.$touch();

              if (
                profValidation.name.$invalid ||
                profValidation.last_name.$invalid ||
                profValidation.department.$invalid ||
                profValidation.dni.$invalid ||
                profValidation.email.$invalid ||
                profValidation.gender.$invalid
              ) {
                return false;
              }
            }
          }
        }
      }

      return true;
    },

    /**
     * Validates partner companies
     */
    validatePartnerCompanies() {
      if (!this.essay.partner_companies?.length) {
        return true;
      }

      for (let index = 0; index < this.essay.partner_companies.length; index++) {
        const companyValidation = this.$v.essay.partner_companies.$each[index];
        if (companyValidation) {
          companyValidation.name.$touch();
          companyValidation.cif.$touch();
          companyValidation.address.$touch();
          companyValidation.responsable.$touch();
          companyValidation.email.$touch();

          if (
            companyValidation.name.$invalid ||
            companyValidation.cif.$invalid ||
            companyValidation.address.$invalid ||
            companyValidation.responsable.$invalid ||
            companyValidation.email.$invalid
          ) {
            return false;
          }
        }
      }

      return true;
    },

    /**
     * Validates actions (basic - only name)
     */
    validateActionsBasic() {
      if (!this.essay.actions?.length) {
        return true;
      }

      return !this.essay.actions.some((action, i) => {
        const validation = this.$v.essay.actions.$each[i];
        if (validation?.name) {
          validation.name.$touch();
          return validation.name.$invalid;
        }
        return false;
      });
    },

    /**
     * Validates actions (complete - all fields)
     */
    validateActionsComplete() {
      if (!this.essay.actions?.length) {
        return true;
      }

      return !this.essay.actions.some((action, i) => {
        const validation = this.$v.essay.actions.$each[i];
        if (!validation) return false;

        validation.name.$touch();
        if (validation.name.$invalid) {
          return true;
        }

        // Validate responsible selection (required in continue/finish mode)
        if (validation.responsible_id) {
          validation.responsible_id.$touch();
          if (validation.responsible_id.$invalid) {
            return true;
          }
        }

        return false;
      });
    },

    /**
     * Validates all achievements (target_achievements and result_achievements)
     */
    validateAllAchievements() {
      if (!this.essay.targets?.length) {
        return true;
      }

      return !this.essay.targets.some((target, i) => {
        // Validate target_achievements
        if (target.target_achievements?.length) {
          const hasInvalid = target.target_achievements.some((achievement, j) => {
            const validation = this.$v.essay.targets.$each[i].target_achievements.$each[j];
            return validation && validation.$invalid;
          });
          if (hasInvalid) return true;
        }

        // Validate result_achievements
        if (target.target_results?.length) {
          return target.target_results.some((result, j) => {
            if (result.result_achievements?.length) {
              return result.result_achievements.some((achievement, k) => {
                const validation =
                  this.$v.essay.targets.$each[i].target_results.$each[j]
                    .result_achievements.$each[k];
                return validation && validation.$invalid;
              });
            }
            return false;
          });
        }

        return false;
      });
    },

    /**
     * Validates targets completely (including achievements)
     */
    validateTargetsComplete() {
      if (!this.essay.targets?.length) {
        return false;
      }

      // First validate basic fields
      if (this.validateTargetsWithoutAchievements()) {
        return false;
      }

      // Then validate achievements
      return this.validateAllAchievements();
    },

    /**
     * Handler for wizard before-change event
     * Used when clicking "Guardar y continuar"
     */
    async handleValidate(currentStepIndex, nextStepIndex, skipSave = false) {
      // Prevent double execution
      if (this.isSaving) {
        return false;
      }

      const currentStep =
        currentStepIndex !== undefined
          ? currentStepIndex
          : this.essay.current_step || 0;

      console.log("currentStep", currentStep);

      // If "Guardar" button was clicked, use save mode
      if (this.draftAction) {
        const isValid = this.validateStep("save", currentStep);
        if (!isValid) {
          notifyValidationFailedAndFocusFirstInvalid(this);
          return false;
        }

        try {
          this.isSaving = true;
          await this.saveEssay();
          return false; // Don't advance step
        } catch (error) {
          this.isSaving = false;
          return false;
        }
      }

      // For "Guardar y continuar", validate with continue mode
      const isValid = this.validateStep("continue", currentStep);
      if (!isValid) {
        notifyValidationFailedAndFocusFirstInvalid(this);
        return false;
      }

      // If skipSave is true, only validate without saving
      if (skipSave) {
        return true;
      }

      // Save and advance step
      const nextStep =
        nextStepIndex !== undefined ? nextStepIndex : currentStep + 1;

      try {
        this.isSaving = true;
        this.justSavedInValidate = true;
        await this.saveCurrentStep(nextStep);
        return true;
      } catch (error) {
        this.isSaving = false;
        this.justSavedInValidate = false;
        return false;
      }
    },

    validateStep2Actions() {
      console.log("Validando acciones en paso 2...");
      let hasError = false;

      this.essay.actions?.forEach((action, i) => {
        const validation = this.$v.essay.actions.$each[i];
        validation.name.$touch();

        Object.keys(validation).forEach((key) => {
          if (validation[key]?.$touch) {
            validation[key].$touch();
          }
        });
        if (validation.name.$invalid) {
          console.log(`❌ Error en actions[${i}]: name es inválido.`);
          hasError = true;
        } else {
          console.log(`✅ actions[${i}].name es válido.`);
        }
      });

      console.log("validaciones de acciones", this.$v.essay.actions.$invalid);
      // Si hay error, mostrar alerta y prevenir el cambio de paso
      if (hasError || this.$v.essay.actions.$invalid) {
        notifyValidationFailedAndFocusFirstInvalid(this);
        return false;
      }

      // Si no hay error, permitir el cambio de paso
      console.log("✅ Paso 2 validado correctamente.");
      return true;
    },
    fakeProgress() {
      // Simula un progreso constante
      this.interval = setInterval(() => {
        if (this.progress < 95) {
          this.progress += 5;
        }
      }, 500);
    },
    saveMsg() {
      Swal.fire({
        icon: "success",
        html: "Se ha guardado correctamente",
        timer: 2000,
        showConfirmButton: false,
      });
    },
    /**
     * Handler for "Guardar" button - saves without advancing step
     */
    async handleSave() {
      if (this.isSaving) {
        return;
      }

      this.draftAction = true;
      this.isSaving = true;

      const currentStep = this.essay.current_step || 0;
      const isValid = this.validateStep("save", currentStep);

      if (!isValid) {
        notifyValidationFailedAndFocusFirstInvalid(this);
        this.isSaving = false;
        return;
      }

      try {
        await this.saveEssay();
      } catch (error) {
        console.error("Error in handleSave:", error);
        this.isSaving = false;
      }
    },

    /**
     * Handler for "Guardar" button in final step - saves without finalizing
     */
    async saveFinishStep() {
      if (this.isSaving) {
        return;
      }

      this.draftAction = true;
      this.isSaving = true;

      const currentStep = this.essay.current_step || 2;
      const isValid = this.validateStep("save", currentStep);

      if (!isValid) {
        notifyValidationFailedAndFocusFirstInvalid(this);
        this.isSaving = false;
        return;
      }

      try {
        await this.saveEssay();
        this.saveMsg();
      } catch (error) {
        console.error("Error in saveFinishStep:", error);
        this.isSaving = false;
      }
    },
  },
  validations: {
    essay: {
      name: { required },
      type: { required },
      primary_project_id: { required },
      description: { required },
      antecedentes: { required },
      arte_status: { required },
      strategic_lines: { required },
      project_phases: { required },
      centers_number: { required, numeric },
      companies_number: { required, numeric },
      professorates_number: { required, numeric },
      students_number: { required, numeric },
      courses: {
        $each: {
          id: { required },
        },
      },
      targets: {
        $each: {
          title: { required },
          description: { required },
          target_results: {
            $each: {
              title: { required },
              description: { required },
              quantitative_qualitative_assessment: { required },
              products_realized: { required },
              educational_community_impact: { required },
              transferability_to_other_centers: { required },
              result_achievements: {
                $each: {
                  name: { required },
                  description: { required },
                  measured_values: { required },
                },
              },
            },
          },
          target_achievements: {
            $each: {
              name: { required },
              description: { required },
              measured_values: { required },
            },
          },
        },
      },
      actions: {
        $each: {
          name: { required },
          descriptions: { required },
          init_date: { required, validDateFormat },
          end_date: { required, validDateFormat, validEndDate },
          responsables: { required },
          responsible_type: { required },
          responsible_id: { required },
          risks: { required },
          contingency_plan: { required },
          economic_forecats: {
            $each: {
              material: { required },
              cost: {
                required,
                noInvalidCharacters,
                validDecimal,
                noCommasOrApostrophes,
              },
            },
          },
          education_activities: {
            $each: {
              name: { required },
              methodology: { required },
            },
          },
        },
      },
      essay_coordinator: {
        center_id: { required },
        document_name: { isPdf },
        selection_adequacy: { required },
        essay_professorates: {
          $each: {
            name: { required, onlyLetters },
            last_name: { required, onlyLetters },
            department: { required },
            dni: { required },
            email: { required, email },
            gender: { required },
          },
        },
      },
      partner_companies: {
        $each: {
          name: { required },
          cif: { required },
          address: { required },
          responsable: { required, onlyLetters },
          email: { required, email },
          document_name: { isPdf },
          selection_adequacy: { required },
        },
      },
      essay_center_partner: {
        $each: {
          center_id: { required },
          document_name: { isPdf },
          selection_adequacy: { required },
          essay_professorates: {
            $each: {
              name: { required, onlyLetters },
              last_name: { required, onlyLetters },
              department: { required },
              dni: { required },
              email: { required, email },
              gender: { required },
            },
          },
        },
      },
    },
  },
};
</script>
<template>
  <div>
    <!-- Single CenterModal instance for both coordinator and partner centers -->
    <CenterModal
      :essay_id="centerModalProps.essay_id"
      :center_type_id="centerModalProps.center_type_id"
      :id="centerModalProps.id"
      modal-id="ModalCenter"
      @success="handleCenterSuccess"
    />
    <b-modal
      :id="id"
      :title="modalTitle"
      @shown="loadData"
      @hide="handleCloseStart"
      @hidden="handleModalClose"
      scrollable
      size="extra-xl"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #default="{}">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body position-relative">
              <!-- Global loading overlay (Vuex-driven) -->
              <loading-overlay :show="globalLoading" :message="saveSpinnerMessage" />
              <form-wizard
                color="#5664d2"
                :start-index="validCurrentStep"
                next-button-text="Guardar y continuar"
                back-button-text="Volver"
                @on-change="handleNextStep"
              >
                <tab-content
                  :before-change="handleValidate"
                  title="Información General y Objetivos"
                >
                  <div class="tab-pane" id="basic-info">
                    <h4 class="card-title">Información</h4>
                    <p class="card-title-desc">Usuario: {{ userName }}</p>
                    <p class="card-title-desc">
                      Fecha de creación: {{ creationDate }}
                    </p>
                    <!-- <form @submit.prevent="submitForm"> -->
                    <div class="form-group">
                      <label for="essayname"
                        >Titulo <span style="color: red">*</span></label
                      >
                      <input
                        v-model="essay.name"
                        id="essayname"
                        name="essayname"
                        type="text"
                        class="form-control"
                        maxlength="200"
                        :class="{ 'is-invalid': $v.essay.name.$error }"
                      />
                      <small class="text-muted"
                        >{{ essay?.name?.length }}/200</small
                      >
                      <div v-if="$v.essay.name.$error" class="invalid-feedback">
                        <div v-if="!$v.essay.name.required">
                          {{ errorMessages.required }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        >Tipo de proyecto <span style="color: red">*</span></label
                      >
                      <div class="mt-2">
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="essayTypeNew"
                            name="essayType"
                            class="custom-control-input"
                            value="new"
                            v-model="essay.type"
                            :class="{
                              'is-invalid': $v.essay.type.$error,
                            }"
                          />
                          <label class="custom-control-label" for="essayTypeNew">
                            Nuevo
                          </label>
                        </div>
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="essayTypeContinuity"
                            name="essayType"
                            class="custom-control-input"
                            value="continuity"
                            v-model="essay.type"
                            :class="{
                              'is-invalid': $v.essay.type.$error,
                            }"
                          />
                          <label
                            class="custom-control-label"
                            for="essayTypeContinuity"
                          >
                            Continuidad
                          </label>
                        </div>
                      </div>
                      <div v-if="$v.essay.type.$error" class="invalid-feedback">
                        <div v-if="!$v.essay.type.required">
                          {{ errorMessages.required }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="primaryProjectId"
                        >Proyecto primario <span style="color: red">*</span></label
                      >
                      <select
                        v-model="essay.primary_project_id"
                        id="primaryProjectId"
                        name="primaryProjectId"
                        class="form-control"
                        :class="{
                          'is-invalid': $v.essay.primary_project_id.$error,
                        }"
                      >
                        <option value="">Seleccione un proyecto primario</option>
                        <option
                          v-for="project in selectOptionsPrimaryProjects"
                          :key="project.id"
                          :value="project.id"
                        >
                          {{ project.name }}
                        </option>
                      </select>
                      <div
                        v-if="$v.essay.primary_project_id.$error"
                        class="invalid-feedback"
                      >
                        <div v-if="!$v.essay.primary_project_id.required">
                          {{ errorMessages.required }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="productdesc"
                        >Descripcion <span style="color: red">*</span></label
                      ><i
                        v-b-tooltip.hover
                        title="Breve descripción del proyecto, 5 líneas"
                        class="far fa-question-circle font-size-12 ml-2"
                      ></i>
                      <app-textarea-ai
                        v-model="essay.description"
                        :enable-ai="true"
                        :max-chars="5000"
                        :rows="3"
                        placeholder="Breve descripción del proyecto, 5 líneas"
                        :textarea-class="{
                          'form-control': true,
                          'is-invalid': $v.essay.description.$error,
                        }"
                        id="productdesc"
                      ></app-textarea-ai>
                      <small class="text-muted"
                        >{{ essay?.description?.length }}/5000</small
                      >
                      <div
                        v-if="$v.essay.description.$error"
                        class="invalid-feedback"
                      >
                        <div v-if="!$v.essay.description.required">
                          {{ errorMessages.required }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="antecedentes"
                        >Antecendentes <span style="color: red">*</span></label
                      ><i
                        v-b-tooltip.hover
                        title="INTERÉS DEL PROYECTO PRESENTADO Y RELACIÓN CON PRÁCTICAS O ACCIONES PREVIAS YA INICIADAS EN LOS CENTROS"
                        class="far fa-question-circle font-size-12 ml-2"
                      ></i>
                      <app-textarea-ai
                        v-model="essay.antecedentes"
                        :enable-ai="true"
                        :max-chars="5000"
                        :rows="3"
                        placeholder="INTERÉS DEL PROYECTO PRESENTADO Y RELACIÓN CON PRÁCTICAS O ACCIONES PREVIAS YA INICIADAS EN LOS CENTROS"
                        :textarea-class="{
                          'form-control': true,
                          'is-invalid': $v.essay.antecedentes.$error,
                        }"
                        id="antecedentes"
                      ></app-textarea-ai>
                      <small class="text-muted"
                        >{{ essay?.antecedentes?.length }}/5000</small
                      >
                      <div
                        v-if="$v.essay.antecedentes.$error"
                        class="invalid-feedback"
                      >
                        <div v-if="!$v.essay.antecedentes.required">
                          {{ errorMessages.required }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="arte_status"
                        >Estado del arte
                        <span style="color: red">*</span></label
                      ><i
                        v-b-tooltip.hover
                        title="Indica brevemente que avances y desarrollos existen actualmente en campos similares al contenido de vuestro proyecto"
                        class="far fa-question-circle font-size-12 ml-2"
                      ></i>
                      <app-textarea-ai
                        v-model="essay.arte_status"
                        :enable-ai="true"
                        :max-chars="5000"
                        :rows="3"
                        placeholder="Indica brevemente que avances y desarrollos existen actualmente en campos similares al contenido de vuestro proyecto"
                        :textarea-class="{
                          'form-control': true,
                          'is-invalid': $v.essay.arte_status.$error,
                        }"
                        id="arte_status"
                      ></app-textarea-ai>
                      <small class="text-muted"
                        >{{ essay?.arte_status?.length }}/5000</small
                      >
                      <div
                        v-if="$v.essay.arte_status.$error"
                        class="invalid-feedback"
                      >
                        <div v-if="!$v.essay.arte_status.required">
                          {{ errorMessages.required }}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="form-group">
                          <label for="manufacturername"
                            >Nº profesorado participante
                            <span style="color: red">*</span></label
                          >
                          <input
                            v-model="essay.professorates_number"
                            id="manufacturername"
                            name="manufacturername"
                            type="number"
                            min="0"
                            step="1"
                            class="form-control"
                            @input="sanitizeNumericInput($event, 'professorates_number')"
                            :class="{
                              'is-invalid':
                                $v.essay.professorates_number.$error,
                            }"
                          />
                          <div
                            v-if="$v.essay.professorates_number.$error"
                            class="invalid-feedback"
                          >
                            <div v-if="!$v.essay.professorates_number.numeric">
                              El campo debe ser numérico.
                            </div>
                            <div
                              v-else-if="
                                !$v.essay.professorates_number.required
                              "
                            >
                              {{ errorMessages.required }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="form-group">
                          <label for="manufacturername"
                            >Nº alumnado involucrado
                            <span style="color: red">*</span></label
                          >
                          <input
                            v-model="essay.students_number"
                            id="manufacturername"
                            name="manufacturername"
                            type="number"
                            min="0"
                            step="1"
                            class="form-control"
                            @input="sanitizeNumericInput($event, 'students_number')"
                            :class="{
                              'is-invalid': $v.essay.students_number.$error,
                            }"
                          />
                          <div
                            v-if="$v.essay.students_number.$error"
                            class="invalid-feedback"
                          >
                            <div v-if="!$v.essay.students_number.numeric">
                              El campo debe ser numérico.
                            </div>
                            <div v-else-if="!$v.essay.students_number.required">
                              {{ errorMessages.required }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="form-group">
                          <label for="manufacturerbrand"
                            >Nº centros <span style="color: red">*</span></label
                          >
                          <input
                            v-model="essay.centers_number"
                            id="manufacturerbrand"
                            name="manufacturerbrand"
                            type="number"
                            min="0"
                            step="1"
                            class="form-control"
                            @input="sanitizeNumericInput($event, 'centers_number')"
                            :class="{
                              'is-invalid': $v.essay.centers_number.$error,
                            }"
                          />
                          <div
                            v-if="$v.essay.centers_number.$error"
                            class="invalid-feedback"
                          >
                            <div v-if="!$v.essay.centers_number.numeric">
                              El campo debe ser numérico.
                            </div>
                            <div v-else-if="!$v.essay.centers_number.required">
                              {{ errorMessages.required }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="form-group">
                          <label for="price"
                            >Nº empresas / Entidades
                            <span style="color: red">*</span></label
                          >
                          <input
                            v-model="essay.companies_number"
                            id="price"
                            name="price"
                            type="number"
                            min="0"
                            step="1"
                            class="form-control"
                            @input="sanitizeNumericInput($event, 'companies_number')"
                            :class="{
                              'is-invalid': $v.essay.companies_number.$error,
                            }"
                          />
                          <div
                            v-if="$v.essay.companies_number.$error"
                            class="invalid-feedback"
                          >
                            <div v-if="!$v.essay.companies_number.numeric">
                              El campo debe ser numérico.
                            </div>
                            <div
                              v-else-if="!$v.essay.companies_number.required"
                            >
                              {{ errorMessages.required }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="productdesc"
                        >Objetivos generales del proyecto
                        <span style="color: red">*</span></label
                      ><i
                        v-b-tooltip.hover
                        title="Seleccionar del desplegable los objetivos generales descritos en la plataforma que se pretenden alcanzar con el proyecto"
                        class="far fa-question-circle font-size-12 ml-2"
                      ></i>
                      <validated-multiselect
                        v-model="essay.strategic_lines"
                        :options="selectOptionsStrategicLines"
                        :validation="$v.essay.strategic_lines"
                        :multiple="true"
                        label="description"
                        track-by="id"
                        placeholder="Selecciona estrategia"
                      ></validated-multiselect>
                    </div>
                    <h4 class="card-title">
                      Objetivos <span style="color: red">*</span>
                      <i
                        v-b-tooltip.hover
                        title="RELACIÓN Y EXPLICACIÓN DE LOS OBJETIVOS GENERALES Y ESPECÍFICOS DE LOS POTENCIALES DESTINATARIOS DE LAS ACCIONES PROPUESTAS (ALUMNADO, PROFESORADO, DEPARTAMENTO DIDÁCTICO, CENTRO EDUCATIVO, FAMILIA/SECTOR PROFESIONAL, EMPRESAS ETC.)."
                        class="far fa-question-circle font-size-12 ml-2"
                      ></i>
                    </h4>
                    <b-card
                      no-body
                      class="mb-1 shadow-none"
                      v-for="(target, i) in essay.targets"
                      :key="i"
                      :set="(v = $v.essay.targets.$each[i])"
                    >
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <h6
                          class="m-0 d-flex justify-content-between align-items-center"
                        >
                          <div class="form-inline">
                            <span>Objetivo: {{ target.title }}</span>
                          </div>
                          <div>
                            <b-icon
                              style="margin-right: 10px"
                              :icon="
                                collapseOpen[i] ? 'chevron-down' : 'chevron-up'
                              "
                              @click="toggleCollapse('collapse-' + i)"
                              v-b-toggle="'collapse-' + i"
                            ></b-icon>
                            <a
                              href="javascript:void(0);"
                              class="text-danger"
                              v-b-tooltip.hover
                              title="Eliminar"
                              @click="deleteRowTarget(i)"
                            >
                              <i class="mdi mdi-trash-can font-size-18"></i>
                            </a>
                          </div>
                        </h6>
                      </b-card-header>
                      <b-collapse
                        :id="'collapse-' + i"
                        accordion="variation-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <div class="col-lg-12">
                              <div class="form-group">
                                <label for="title"
                                  >Título
                                  <span style="color: red">*</span></label
                                >
                                <input
                                  type="text"
                                  v-model="target.title"
                                  class="form-control"
                                  id="title"
                                  placeholder="Título"
                                  maxlength="200"
                                  :class="{ 'is-invalid': v.title.$error }"
                                />
                                <!-- Recuento de caracteres -->
                                <small class="text-muted"
                                  >{{ target?.title?.length }}/200</small
                                >
                                <div
                                  v-if="v.title.$error"
                                  class="invalid-feedback"
                                >
                                  <div v-if="!v.title.required">
                                    {{ errorMessages.required }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <div class="form-group">
                                <label for="descriptionTarget"
                                  >Descripción
                                  <span style="color: red">*</span></label
                                >
                                <app-textarea-ai
                                  v-model="target.description"
                                  :enable-ai="true"
                                  :max-chars="5000"
                                  :rows="3"
                                  placeholder="Descripción"
                                  :textarea-class="{
                                    'form-control': true,
                                    'is-invalid': v.description.$error,
                                  }"
                                  id="descriptionTarget"
                                ></app-textarea-ai>
                                <small class="text-muted"
                                  >{{ target?.description?.length }}/5000</small
                                >
                                <div
                                  v-if="v.description.$error"
                                  class="invalid-feedback"
                                >
                                  <div v-if="!v.description.required">
                                    {{ errorMessages.required }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <label>Resultados
                              <i
                                v-b-tooltip.hover
                                title="RESULTADOS QUE SE ESPERA CONSEGUIR CON RESPECTO A LOS OBJETIVOS ESPECIFICADOS . SI PROCEDE, INDICAR TAMBIÉN SI LOS BENEFICIOS DEL PROYECTO SE TRASLADARÁN AL ALUMNADO, AL PROFESORADO, AL DEPARTAMENTO, A OTROS CENTROS EDUCATIVOS O AL PROPIO CENTRO, A LA FAMILIA/SECTOR PROFESIONAL, A LAS EMPRESAS, ETC."
                                class="far fa-question-circle font-size-12 ml-2"
                              ></i>
                            </label>
                            <b-card
                              no-body
                              class="mb-1 shadow-none"
                              v-for="(
                                target_result, j
                              ) in target.target_results"
                              :key="'target-result-' + j"
                              :set="(vresult = v.target_results.$each[j])"
                            >
                              <!-- <b-card no-body class="mb-1 shadow-none" v-for="(target_result, j) in target.target_results" :key="'target-result-' + j"> -->
                              <b-card-header
                                header-tag="header"
                                class="p-1"
                                role="tab"
                              >
                                <h6
                                  class="m-0 d-flex justify-content-between align-items-center"
                                >
                                  <div class="form-inline">
                                    <span
                                      >Resultado:
                                      {{ target_result.title }}</span
                                    >
                                  </div>
                                  <div>
                                    <b-icon
                                      style="margin-right: 10px"
                                      :icon="
                                        collapseOpen[
                                          'target-result-collapse-' + j
                                        ]
                                          ? 'chevron-down'
                                          : 'chevron-up'
                                      "
                                      @click="
                                        toggleCollapse(
                                          'target-result-collapse-' + j
                                        )
                                      "
                                      v-b-toggle="'target-result-collapse-' + j"
                                    ></b-icon>
                                    <a
                                      href="javascript:void(0);"
                                      class="text-danger"
                                      v-b-tooltip.hover
                                      title="Eliminar"
                                      @click="deleteRowTargetResult(i, j)"
                                    >
                                      <i
                                        class="mdi mdi-trash-can font-size-18"
                                      ></i>
                                    </a>
                                  </div>
                                </h6>
                              </b-card-header>
                              <b-collapse
                                :id="'target-result-collapse-' + j"
                                accordion="variation-accordion-target-result"
                                role="tabpanel"
                              >
                                <b-card-body>
                                  <b-card-text>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="title"
                                          >Título
                                          <span style="color: red"
                                            >*</span
                                          ></label
                                        >
                                        <input
                                          type="text"
                                          v-model="target_result.title"
                                          class="form-control"
                                          id="title"
                                          placeholder="Título"
                                          maxlength="200"
                                          :class="{
                                            'is-invalid':
                                              vresult?.title?.$error,
                                          }"
                                        />
                                        <small class="text-muted"
                                          >{{
                                            target_result?.title?.length
                                          }}/200</small
                                        >
                                        <div
                                          v-if="vresult?.title?.$error"
                                          class="invalid-feedback"
                                        >
                                          <div v-if="!vresult?.title?.required">
                                            {{ errorMessages.required }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="descriptionTargetResult"
                                          >Descripción
                                          <span style="color: red"
                                            >*</span
                                          ></label
                                        >
                                        <app-textarea-ai
                                          v-model="target_result.description"
                                          :enable-ai="true"
                                          :max-chars="5000"
                                          :rows="3"
                                          placeholder="Descripción"
                                          :textarea-class="{
                                            'form-control': true,
                                            'is-invalid':
                                              vresult.description.$error,
                                          }"
                                          id="descriptionTargetResult"
                                        ></app-textarea-ai>
                                        <small class="text-muted"
                                          >{{
                                            target_result?.description?.length
                                          }}/5000</small
                                        >
                                        <div
                                          v-if="vresult.description.$error"
                                          class="invalid-feedback"
                                        >
                                          <div
                                            v-if="!vresult.description.required"
                                          >
                                            {{ errorMessages.required }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="quantitative_qualitative_assessment"
                                          >Valoración en términos cuantitativos y cualitativos de los resultados esperados
                                          <span style="color: red">*</span></label
                                        >
                                        <app-textarea-ai
                                          v-model="target_result.quantitative_qualitative_assessment"
                                          :enable-ai="true"
                                          :max-chars="5000"
                                          :rows="3"
                                          placeholder="Valoración en términos cuantitativos y cualitativos de los resultados esperados"
                                          :textarea-class="{
                                            'form-control': true,
                                            'is-invalid':
                                              vresult.quantitative_qualitative_assessment?.$error,
                                          }"
                                          id="quantitative_qualitative_assessment"
                                        ></app-textarea-ai>
                                        <small class="text-muted"
                                          >{{
                                            target_result?.quantitative_qualitative_assessment?.length || 0
                                          }}/5000</small
                                        >
                                        <div
                                          v-if="vresult.quantitative_qualitative_assessment?.$error"
                                          class="invalid-feedback"
                                        >
                                          <div
                                            v-if="!vresult.quantitative_qualitative_assessment?.required"
                                          >
                                            {{ errorMessages.required }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="products_realized"
                                          >Productos realizados
                                          <span style="color: red">*</span></label
                                        >
                                        <app-textarea-ai
                                          v-model="target_result.products_realized"
                                          :enable-ai="true"
                                          :max-chars="5000"
                                          :rows="3"
                                          placeholder="Productos realizados"
                                          :textarea-class="{
                                            'form-control': true,
                                            'is-invalid':
                                              vresult.products_realized?.$error,
                                          }"
                                          id="products_realized"
                                        ></app-textarea-ai>
                                        <small class="text-muted"
                                          >{{
                                            target_result?.products_realized?.length || 0
                                          }}/5000</small
                                        >
                                        <div
                                          v-if="vresult.products_realized?.$error"
                                          class="invalid-feedback"
                                        >
                                          <div
                                            v-if="!vresult.products_realized?.required"
                                          >
                                            {{ errorMessages.required }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="educational_community_impact"
                                          >Impacto del proyecto dentro de la comunidad educativa
                                          <span style="color: red">*</span></label
                                        >
                                        <app-textarea-ai
                                          v-model="target_result.educational_community_impact"
                                          :enable-ai="true"
                                          :max-chars="5000"
                                          :rows="3"
                                          placeholder="Impacto del proyecto dentro de la comunidad educativa"
                                          :textarea-class="{
                                            'form-control': true,
                                            'is-invalid':
                                              vresult.educational_community_impact?.$error,
                                          }"
                                          id="educational_community_impact"
                                        ></app-textarea-ai>
                                        <small class="text-muted"
                                          >{{
                                            target_result?.educational_community_impact?.length || 0
                                          }}/5000</small
                                        >
                                        <div
                                          v-if="vresult.educational_community_impact?.$error"
                                          class="invalid-feedback"
                                        >
                                          <div
                                            v-if="!vresult.educational_community_impact?.required"
                                          >
                                            {{ errorMessages.required }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="transferability_to_other_centers"
                                          >Posibilidades de transferencia de resultados a otros centros educativos de formación profesional
                                          <span style="color: red">*</span></label
                                        >
                                        <app-textarea-ai
                                          v-model="target_result.transferability_to_other_centers"
                                          :enable-ai="true"
                                          :max-chars="5000"
                                          :rows="3"
                                          placeholder="Posibilidades de transferencia de resultados a otros centros educativos de formación profesional"
                                          :textarea-class="{
                                            'form-control': true,
                                            'is-invalid':
                                              vresult.transferability_to_other_centers?.$error,
                                          }"
                                          id="transferability_to_other_centers"
                                        ></app-textarea-ai>
                                        <small class="text-muted"
                                          >{{
                                            target_result?.transferability_to_other_centers?.length || 0
                                          }}/5000</small
                                        >
                                        <div
                                          v-if="vresult.transferability_to_other_centers?.$error"
                                          class="invalid-feedback"
                                        >
                                          <div
                                            v-if="!vresult.transferability_to_other_centers?.required"
                                          >
                                            {{ errorMessages.required }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="other_expected_results"
                                          >Otros resultados esperados</label
                                        >
                                        <app-textarea-ai
                                          v-model="target_result.other_expected_results"
                                          :enable-ai="true"
                                          :max-chars="5000"
                                          :rows="3"
                                          placeholder="Otros resultados esperados"
                                          textarea-class="form-control"
                                          id="other_expected_results"
                                        ></app-textarea-ai>
                                        <small class="text-muted"
                                          >{{
                                            target_result?.other_expected_results?.length || 0
                                          }}/5000</small
                                        >
                                      </div>
                                    </div>
                                    <hr style="border-top: 2px solid rgb(0 0 0 / 10%); margin: 20px 0;" />
                                    <h5 class="card-title mt-3">
                                      Plan de difusión y explotación de los resultados
                                      <i
                                        v-b-tooltip.hover
                                        title="EXPLICACIÓN Y ESPECIFICACIÓN DE LAS ACCIONES, SOPORTES Y/O INSTRUMENTOS QUE SE UTILIZARÁN PARA DAR A CONOCER E INCREMENTAR LAS POSIBILIDADES DE DIFUSIÓN, APLICACIÓN Y TRANSFERENCIA DE LOS RESULTADOS CONSEGUIDOS, EN FUNCIÓN DE LA NATURALEZA Y CARACTERÍSTICAS PARTICULARES DEL PROYECTO. ENTRE OTROS MEDIOS, PROCEDE VALORAR COMUNICACIONES EN JORNADAS Y CONGRESOS, LICENCIAS DE EXPLOTACIÓN O PATENTES, CONVENIOS, PARTICIPACIÓN EN REDES, PROPUESTAS SUCESIVAS A PROGRAMAS INTERNACIONALES, ETC."
                                        class="far fa-question-circle font-size-12 ml-2"
                                      ></i>
                                    </h5>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="communications_conferences"
                                          >Comunicaciones en jornadas y congresos</label
                                        >
                                        <app-textarea-ai
                                          v-model="target_result.communications_conferences"
                                          :enable-ai="true"
                                          :max-chars="5000"
                                          :rows="3"
                                          placeholder="Comunicaciones en jornadas y congresos"
                                          textarea-class="form-control"
                                          id="communications_conferences"
                                        ></app-textarea-ai>
                                        <small class="text-muted"
                                          >{{
                                            target_result?.communications_conferences?.length || 0
                                          }}/5000</small
                                        >
                                      </div>
                                    </div>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="exploitation_licenses_patents"
                                          >Licencias de explotación o patentes</label
                                        >
                                        <app-textarea-ai
                                          v-model="target_result.exploitation_licenses_patents"
                                          :enable-ai="true"
                                          :max-chars="5000"
                                          :rows="3"
                                          placeholder="Licencias de explotación o patentes"
                                          textarea-class="form-control"
                                          id="exploitation_licenses_patents"
                                        ></app-textarea-ai>
                                        <small class="text-muted"
                                          >{{
                                            target_result?.exploitation_licenses_patents?.length || 0
                                          }}/5000</small
                                        >
                                      </div>
                                    </div>
                                    <div class="col-lg-12">
                                      <div class="form-group">
                                        <label for="agreements_networks_proposals"
                                          >Convenios, participación en redes, propuestas sucesivas a programas internacionales, etc.</label
                                        >
                                        <app-textarea-ai
                                          v-model="target_result.agreements_networks_proposals"
                                          :enable-ai="true"
                                          :max-chars="5000"
                                          :rows="3"
                                          placeholder="Convenios, participación en redes, propuestas sucesivas a programas internacionales, etc."
                                          textarea-class="form-control"
                                          id="agreements_networks_proposals"
                                        ></app-textarea-ai>
                                        <small class="text-muted"
                                          >{{
                                            target_result?.agreements_networks_proposals?.length || 0
                                          }}/5000</small
                                        >
                                      </div>
                                    </div>
                                  </b-card-text>
                                </b-card-body>
                              </b-collapse>
                            </b-card>
                            <a
                              href="javascript:void(0);"
                              class="text-success"
                              @click="addRowResults(target)"
                            >
                              <i class="mdi mdi-plus-circle font-size-18"></i>
                              Agregar nuevo resultado
                            </a>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                    <a
                      href="javascript:void(0);"
                      class="text-success"
                      @click="addRow()"
                    >
                      <i class="mdi mdi-plus-circle font-size-18"></i> Agregar
                      nuevo objetivo
                    </a>
                    <!-- </form> -->
                  </div>
                </tab-content>
                <tab-content
                  :before-change="handleValidate"
                  title="Centros y Empresas"
                >
                  <div class="tab-pane" id="product-img">
                    <h4 class="card-title">Centro Coordinador</h4>
                    <div class="form-group col-12 mt-4">
                      <div class="row">
                        <div class="form-group col-12">
                          <label
                            >Centro coordinador
                            <span style="color: red">*</span></label
                          >
                          <!-- Show center info if exists, otherwise show add button -->
                          <div v-if="coordinatorCenter && coordinatorCenter.id">
                            <b-card class="mb-3">
                              <div class="d-flex justify-content-between align-items-start">
                                <div class="flex-grow-1">
                                  <h5 class="mb-2">{{ coordinatorCenter.name }}</h5>
                                  <p class="mb-1">
                                    <strong>Código:</strong> {{ coordinatorCenter.center_code }}
                                  </p>
                                  <p class="mb-1">
                                    <strong>Dirección:</strong> {{ coordinatorCenter.address }}, {{ coordinatorCenter.city }}, {{ coordinatorCenter.province }}
                                  </p>
                                  <p class="mb-1">
                                    <strong>Email:</strong> {{ coordinatorCenter.email }}
                                  </p>
                                  <p class="mb-1">
                                    <strong>Teléfono:</strong> {{ coordinatorCenter.phone }}
                                  </p>
                                  <p class="mb-0">
                                    <strong>Director/a:</strong> {{ coordinatorCenter.director }}
                                  </p>
                                </div>
                                <div>
                                  <b-button
                                    variant="primary"
                                    size="sm"
                                    @click="openCenterModal"
                                    class="ml-2"
                                  >
                                    <i class="mdi mdi-pencil"></i> Editar
                                  </b-button>
                                </div>
                              </div>
                            </b-card>
                          </div>
                          <div v-else>
                            <b-button
                              variant="success"
                              @click="openCenterModal"
                              :class="{
                                'is-invalid':
                                  $v.essay.essay_coordinator.center_id.$error,
                              }"
                            >
                              <i class="mdi mdi-plus-circle"></i> Añadir Centro Coordinador
                            </b-button>
                            <div
                              v-if="$v.essay.essay_coordinator.center_id.$error"
                              class="invalid-feedback d-block"
                            >
                              <div v-if="!$v.essay.essay_coordinator.center_id.required">
                                {{ errorMessages.required }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <label for="file">Profesorado participante</label>
                      <table class="table table-bordered table-sticky-header">
                        <thead>
                          <tr>
                            <th scope="col">
                              Nombre <span style="color: red">*</span>
                            </th>
                            <th scope="col">
                              Apellido <span style="color: red">*</span>
                            </th>
                            <th scope="col">
                              Género <span style="color: red">*</span>
                            </th>
                            <th scope="col">
                              Departamento <span style="color: red">*</span>
                            </th>
                            <th scope="col">DNI <span style="color: red">*</span></th>
                            <th scope="col">
                              Email <span style="color: red">*</span>
                            </th>
                            <th scope="col">Rango de edad</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(professorate, i) in essay?.essay_coordinator
                              ?.essay_professorates"
                            :key="i"
                            :set="
                              (vcoordinator =
                                $v.essay.essay_coordinator.essay_professorates
                                  .$each[i])
                            "
                            class=""
                          >
                            <td>
                              <div class="form-group">
                                <input
                                  type="text"
                                  v-model="professorate.name"
                                  class="form-control"
                                  placeholder="Nombre"
                                  maxlength="200"
                                  :class="{
                                    'is-invalid': vcoordinator.name.$error,
                                  }"
                                />
                                <small class="text-muted"
                                  >{{ professorate?.name?.length }}/200</small
                                >
                                <div
                                  v-if="vcoordinator.name.$error"
                                  class="invalid-feedback"
                                >
                                  <div v-if="!vcoordinator.name.required">
                                    {{ errorMessages.required }}
                                  </div>
                                  <div
                                    v-else-if="!vcoordinator.name.onlyLetters"
                                  >
                                    {{ errorMessages.onlyLetters }}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input
                                  type="text"
                                  v-model="professorate.last_name"
                                  class="form-control"
                                  placeholder="Apellido"
                                  maxlength="200"
                                  :class="{
                                    'is-invalid': vcoordinator.last_name?.$error,
                                  }"
                                />
                                <small class="text-muted"
                                  >{{ professorate?.last_name?.length }}/200</small
                                >
                                <div
                                  v-if="vcoordinator.last_name?.$error"
                                  class="invalid-feedback"
                                >
                                  <div v-if="!vcoordinator.last_name?.required">
                                    {{ errorMessages.required }}
                                  </div>
                                  <div
                                    v-else-if="!vcoordinator.last_name?.onlyLetters"
                                  >
                                    {{ errorMessages.onlyLetters }}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <select
                                  v-model="professorate.gender"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': vcoordinator.gender?.$error,
                                  }"
                                >
                                  <option :value="null">Seleccionar género</option>
                                  <option
                                    v-for="option in genderOptions"
                                    :key="option.value"
                                    :value="option.value"
                                  >
                                    {{ option.label }}
                                  </option>
                                </select>
                                <div
                                  v-if="vcoordinator.gender?.$error"
                                  class="invalid-feedback"
                                >
                                  <div v-if="!vcoordinator.gender?.required">
                                    {{ errorMessages.required }}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input
                                  type="text"
                                  v-model="professorate.department"
                                  class="form-control"
                                  placeholder="Departamento"
                                  maxlength="200"
                                  :class="{
                                    'is-invalid':
                                      vcoordinator.department.$error,
                                  }"
                                />
                                <small class="text-muted"
                                  >{{
                                    professorate?.department?.length
                                  }}/200</small
                                >
                                <div
                                  v-if="vcoordinator.department.$error"
                                  class="invalid-feedback"
                                >
                                  <div v-if="!vcoordinator.department.required">
                                    {{ errorMessages.required }}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input
                                  type="text"
                                  v-model="professorate.dni"
                                  class="form-control"
                                  placeholder="DNI"
                                  maxlength="10"
                                  :class="{
                                    'is-invalid': vcoordinator.dni.$error,
                                  }"
                                />
                                <small class="text-muted"
                                  >{{ professorate?.dni?.length }}/10</small
                                >
                                <div
                                  v-if="vcoordinator.dni.$error"
                                  class="invalid-feedback"
                                >
                                  <div v-if="!vcoordinator.dni.required">
                                    {{ errorMessages.required }}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input
                                  type="text"
                                  v-model="professorate.email"
                                  class="form-control"
                                  placeholder="Email"
                                  :class="{
                                    'is-invalid': vcoordinator.email.$error,
                                  }"
                                />
                                <div
                                  v-if="vcoordinator.email.$error"
                                  class="invalid-feedback"
                                >
                                  <div v-if="!vcoordinator.email.required">
                                    {{ errorMessages.required }}
                                  </div>
                                  <div v-else-if="!vcoordinator.email.email">
                                    {{ errorMessages.email }}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <select
                                  v-model="professorate.age_range"
                                  class="form-control"
                                >
                                  <option :value="null">Seleccionar rango de edad</option>
                                  <option
                                    v-for="option in ageRangeOptions"
                                    :key="option.value"
                                    :value="option.value"
                                  >
                                    {{ option.label }}
                                  </option>
                                </select>
                              </div>
                            </td>
                            <td class="text-center">
                              <a
                                href="javascript:void(0);"
                                class="text-danger"
                                v-b-tooltip.hover
                                title="Eliminar"
                                @click="deleteRowProfessorate(i)"
                              >
                                <i class="mdi mdi-trash-can font-size-18"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="8" class="text-right">
                              <a
                                href="javascript:void(0);"
                                class="text-success"
                                @click="addRowProfessorate()"
                              >
                                <i class="mdi mdi-plus-circle font-size-18"></i>
                                Agregar profesorado
                              </a>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                      <div class="form-group mt-4">
                        <label for="selection_adequacy">
                          IDONEIDAD DE LA ELECCIÓN
                          <span style="color: red">*</span>
                        </label>
                        <i
                          v-b-tooltip.hover
                          title="IDONEIDAD DE LA ELECCIÓN DE LOS PARTICIPANTES (CENTROS, EMPRESAS, ENTIDADES) QUE FORMAN PARTE DEL PROYECTO, VALORANDO LA APORTACIÓN DE CADA UNO DE ELLOS A LA MATERIALIZACIÓN DE LOS OBJETIVOS QUE SE PRETENDEN ALCANZAR."
                          class="far fa-question-circle font-size-12 ml-2"
                        ></i>
                        <app-textarea-ai
                          v-model="essay.essay_coordinator.selection_adequacy"
                          :enable-ai="true"
                          :max-chars="5000"
                          :rows="4"
                          placeholder="IDONEIDAD DE LA ELECCIÓN DE LOS PARTICIPANTES (CENTROS, EMPRESAS, ENTIDADES) QUE FORMAN PARTE DEL PROYECTO, VALORANDO LA APORTACIÓN DE CADA UNO DE ELLOS A LA MATERIALIZACIÓN DE LOS OBJETIVOS QUE SE PRETENDEN ALCANZAR."
                          :textarea-class="{
                            'form-control': true,
                            'is-invalid': $v.essay.essay_coordinator.selection_adequacy.$error,
                          }"
                          id="selection_adequacy"
                        ></app-textarea-ai>
                        <small class="text-muted">
                          {{
                            essay?.essay_coordinator?.selection_adequacy?.length || 0
                          }}/5000
                        </small>
                        <div
                          v-if="$v.essay.essay_coordinator.selection_adequacy.$error"
                          class="invalid-feedback"
                        >
                          <div
                            v-if="!$v.essay.essay_coordinator.selection_adequacy.required"
                          >
                            {{ errorMessages.required }}
                          </div>
                        </div>
                      </div>
                      <b-alert show variant="warning">
                        Observaciones<br />
                        <ul>
                          <li>
                            Para poder generar el 
                            <strong>documento de autorización de centro coordinador</strong> 
                            con los datos introducidos, primero debes seleccionar centro coordinador y añadir profesorado participante.
                          </li>
                          <li>
                            En caso de no añadir profesorado participante, estos
                            no estarán reflejados en el <strong>documento</strong>
                          </li>
                        </ul>
                      </b-alert>
                      <div class="form-inline mt-5">
                        <div class="form-group col-2">
                          <label for="file">Descargar Documento:</label>
                          <button
                            id="btn-anexoI"
                            @click.prevent="downloadFileAnexoI()"
                            class="btn btn-info mr-4"
                            :disabled="!essay.essay_coordinator.center_id"
                          >
                            <i class="fas fa-file-download mr-2"></i> Documento
                          </button>
                        </div>
                        <div class="form-group col-10">
                          <label for="file"
                            >Documento de aprobación del claustro y consejo
                            escolar:</label
                          >
                          <div class="custom-file">
                            <input
                              id="inputFile"
                              type="file"
                              ref="fileInput"
                              name="file"
                              class="custom-file-input"
                              @change="onFileCoordinatorChange"
                              :class="{
                                'is-invalid':
                                  $v.essay.essay_coordinator.document_name
                                    .$error,
                              }"
                              data-browse="Selecciona"
                              accept="application/pdf"
                            />
                            <label class="custom-file-label" for="inputFile">
                              {{
                                essay.essay_coordinator.document_name ||
                                "Seleccione un archivo"
                              }}
                            </label>
                            <div
                              v-if="
                                $v.essay.essay_coordinator.document_name.$error
                              "
                              class="invalid-feedback"
                            >
                              <div
                                v-if="
                                  !$v.essay.essay_coordinator.document_name
                                    .isPdf
                                "
                              >
                                Solo se permiten archivos PDF.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr style="border-top: 5px solid rgb(0 0 0 / 10%)" />
                    <h4 class="card-title mt-4">Centro colaborador</h4>
                    <b-card
                      no-body
                      class="mb-4 shadow-none mt-4"
                      v-for="(center, i) in essay.essay_center_partner"
                      :key="i"
                      :set="(vpartner = $v.essay.essay_center_partner.$each[i])"
                    >
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <h6
                          class="m-0 d-flex justify-content-between align-items-center"
                        >
                          <div class="form-inline">
                            <span
                              >Centro colaborador
                              {{
                                partnerCenters[i] && partnerCenters[i].name
                                  ? partnerCenters[i].name
                                  : 'Sin centro asignado'
                              }}</span
                            >
                          </div>
                          <div>
                            <b-icon
                              style="margin-right: 10px"
                              :icon="
                                collapseOpen[i] ? 'chevron-down' : 'chevron-up'
                              "
                              @click="toggleCollapse('collapse-' + i)"
                              v-b-toggle="'collapse-' + i"
                            ></b-icon>
                            <a
                              href="javascript:void(0);"
                              class="text-danger"
                              v-b-tooltip.hover
                              title="Eliminar"
                              @click="deleteCenterPartner(i)"
                            >
                              <i class="mdi mdi-trash-can font-size-18"></i>
                            </a>
                          </div>
                        </h6>
                      </b-card-header>
                      <b-collapse
                        :id="'collapse-' + i"
                        accordion="variation-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="form-group">
                                  <label
                                    >Centro colaborador
                                    <span style="color: red">*</span></label
                                  >
                                  <!-- Show center info if exists, otherwise show add button -->
                                  <div v-if="partnerCenters[i] && partnerCenters[i].id">
                                    <b-card class="mb-3">
                                      <div class="d-flex justify-content-between align-items-start">
                                        <div class="flex-grow-1">
                                          <h5 class="mb-2">{{ partnerCenters[i].name }}</h5>
                                          <p class="mb-1">
                                            <strong>Código:</strong> {{ partnerCenters[i].center_code }}
                                          </p>
                                          <p class="mb-1">
                                            <strong>Dirección:</strong> {{ partnerCenters[i].address }}, {{ partnerCenters[i].city }}, {{ partnerCenters[i].province }}
                                          </p>
                                          <p class="mb-1">
                                            <strong>Email:</strong> {{ partnerCenters[i].email }}
                                          </p>
                                          <p class="mb-1">
                                            <strong>Teléfono:</strong> {{ partnerCenters[i].phone }}
                                          </p>
                                          <p class="mb-0">
                                            <strong>Director/a:</strong> {{ partnerCenters[i].director }}
                                          </p>
                                        </div>
                                        <div>
                                          <b-button
                                            variant="primary"
                                            size="sm"
                                            @click="openPartnerCenterModal(i)"
                                            class="ml-2"
                                          >
                                            <i class="mdi mdi-pencil"></i> Editar
                                          </b-button>
                                        </div>
                                      </div>
                                    </b-card>
                                  </div>
                                  <div v-else>
                                    <b-button
                                      variant="success"
                                      @click="openPartnerCenterModal(i)"
                                      :class="{
                                        'is-invalid': vpartner.center_id.$error,
                                      }"
                                    >
                                      <i class="mdi mdi-plus-circle"></i> Añadir Centro Colaborador
                                    </b-button>
                                    <div
                                      v-if="vpartner.center_id.$error"
                                      class="invalid-feedback d-block"
                                    >
                                      <div v-if="!vpartner.center_id.required">
                                        {{ errorMessages.required }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <label for="file">Profesorado participante</label>
                            <table
                              class="table table-bordered table-sticky-header"
                            >
                              <thead>
                                <tr>
                                  <th scope="col">
                                    Nombre <span style="color: red">*</span>
                                  </th>
                                  <th scope="col">
                                    Apellido <span style="color: red">*</span>
                                  </th>
                                  <th scope="col">
                                    Género <span style="color: red">*</span>
                                  </th>
                                  <th scope="col">
                                    Departamento
                                    <span style="color: red">*</span>
                                  </th>
                                  <th scope="col">
                                    DNI <span style="color: red">*</span>
                                  </th>
                                  <th scope="col">
                                    Email <span style="color: red">*</span>
                                  </th>
                                  <th scope="col">Rango de edad</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(
                                    professorate, j
                                  ) in center.essay_professorates"
                                  :key="j"
                                  class=""
                                  :set="
                                    (vprofessorate =
                                      vpartner.essay_professorates.$each[j])
                                  "
                                >
                                  <td>
                                    <div class="form-group">
                                      <input
                                        type="text"
                                        v-model="professorate.name"
                                        class="form-control"
                                        placeholder="Nombre"
                                        maxlength="200"
                                        :class="{
                                          'is-invalid':
                                            vprofessorate.name.$error,
                                        }"
                                      />
                                      <div
                                        v-if="vprofessorate.name.$error"
                                        class="invalid-feedback"
                                      >
                                        <div
                                          v-if="!vprofessorate.name.required"
                                        >
                                          {{ errorMessages.required }}
                                        </div>
                                        <div
                                          v-else-if="
                                            !vprofessorate.name.onlyLetters
                                          "
                                        >
                                          {{ errorMessages.onlyLetters }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="form-group">
                                      <input
                                        type="text"
                                        v-model="professorate.last_name"
                                        class="form-control"
                                        placeholder="Apellido"
                                        maxlength="200"
                                        :class="{
                                          'is-invalid':
                                            vprofessorate.last_name?.$error,
                                        }"
                                      />
                                      <small class="text-muted"
                                        >{{ professorate?.last_name?.length }}/200</small
                                      >
                                      <div
                                        v-if="vprofessorate.last_name?.$error"
                                        class="invalid-feedback"
                                      >
                                        <div
                                          v-if="!vprofessorate.last_name?.required"
                                        >
                                          {{ errorMessages.required }}
                                        </div>
                                        <div
                                          v-else-if="
                                            !vprofessorate.last_name?.onlyLetters
                                          "
                                        >
                                          {{ errorMessages.onlyLetters }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="form-group">
                                      <select
                                        v-model="professorate.gender"
                                        class="form-control"
                                        :class="{
                                          'is-invalid': vprofessorate.gender?.$error,
                                        }"
                                      >
                                        <option :value="null">Seleccionar género</option>
                                        <option
                                          v-for="option in genderOptions"
                                          :key="option.value"
                                          :value="option.value"
                                        >
                                          {{ option.label }}
                                        </option>
                                      </select>
                                      <div
                                        v-if="vprofessorate.gender?.$error"
                                        class="invalid-feedback"
                                      >
                                        <div v-if="!vprofessorate.gender?.required">
                                          {{ errorMessages.required }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="form-group">
                                      <input
                                        type="text"
                                        v-model="professorate.department"
                                        class="form-control"
                                        placeholder="Departamento"
                                        maxlength="200"
                                        :class="{
                                          'is-invalid':
                                            vprofessorate.department.$error,
                                        }"
                                      />
                                      <div
                                        div
                                        v-if="vprofessorate.department.$error"
                                        class="invalid-feedback"
                                      >
                                        <div
                                          v-if="
                                            !vprofessorate.department.required
                                          "
                                        >
                                          {{ errorMessages.required }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="form-group">
                                      <input
                                        type="text"
                                        v-model="professorate.dni"
                                        class="form-control"
                                        placeholder="DNI"
                                        maxlength="10"
                                        :class="{
                                          'is-invalid':
                                            vprofessorate.dni.$error,
                                        }"
                                      />
                                      <div
                                        div
                                        v-if="vprofessorate.dni.$error"
                                        class="invalid-feedback"
                                      >
                                        <div v-if="!vprofessorate.dni.required">
                                          {{ errorMessages.required }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="form-group">
                                      <input
                                        type="text"
                                        v-model="professorate.email"
                                        class="form-control"
                                        placeholder="Email"
                                        :class="{
                                          'is-invalid':
                                            vprofessorate.email.$error,
                                        }"
                                      />
                                      <div
                                        div
                                        v-if="vprofessorate.email.$error"
                                        class="invalid-feedback"
                                      >
                                        <div
                                          v-if="!vprofessorate.email.required"
                                        >
                                          {{ errorMessages.required }}
                                        </div>
                                        <div
                                          v-else-if="!vprofessorate.email.email"
                                        >
                                          {{ errorMessages.email }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="form-group">
                                      <select
                                        v-model="professorate.age_range"
                                        class="form-control"
                                      >
                                        <option :value="null">Seleccionar rango de edad</option>
                                        <option
                                          v-for="option in ageRangeOptions"
                                          :key="option.value"
                                          :value="option.value"
                                        >
                                          {{ option.label }}
                                        </option>
                                      </select>
                                    </div>
                                  </td>
                                  <td class="text-center">
                                    <a
                                      href="javascript:void(0);"
                                      class="text-danger"
                                      v-b-tooltip.hover
                                      title="Eliminar"
                                      @click="
                                        deleteRowProfessoratePartner(center, j)
                                      "
                                    >
                                      <i
                                        class="mdi mdi-trash-can font-size-18"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td colspan="8" class="text-right">
                                    <a
                                      href="javascript:void(0);"
                                      class="text-success"
                                      @click="addRowProfessoratePartner(center)"
                                    >
                                      <i
                                        class="mdi mdi-plus-circle font-size-18"
                                      ></i>
                                      Agregar profesorado
                                    </a>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                            <div class="form-group mt-4">
                              <label for="selection_adequacy_partner">
                                IDONEIDAD DE LA ELECCIÓN
                                <span style="color: red">*</span>
                              </label>
                              <i
                                v-b-tooltip.hover
                                title="IDONEIDAD DE LA ELECCIÓN DE LOS PARTICIPANTES (CENTROS, EMPRESAS, ENTIDADES) QUE FORMAN PARTE DEL PROYECTO, VALORANDO LA APORTACIÓN DE CADA UNO DE ELLOS A LA MATERIALIZACIÓN DE LOS OBJETIVOS QUE SE PRETENDEN ALCANZAR."
                                class="far fa-question-circle font-size-12 ml-2"
                              ></i>
                              <app-textarea-ai
                                v-model="center.selection_adequacy"
                                :enable-ai="true"
                                :max-chars="5000"
                                :rows="4"
                                placeholder="IDONEIDAD DE LA ELECCIÓN DE LOS PARTICIPANTES (CENTROS, EMPRESAS, ENTIDADES) QUE FORMAN PARTE DEL PROYECTO, VALORANDO LA APORTACIÓN DE CADA UNO DE ELLOS A LA MATERIALIZACIÓN DE LOS OBJETIVOS QUE SE PRETENDEN ALCANZAR."
                                :textarea-class="{
                                  'form-control': true,
                                  'is-invalid': vpartner.selection_adequacy.$error,
                                }"
                                id="selection_adequacy_partner"
                              ></app-textarea-ai>
                              <small class="text-muted">
                                {{ center?.selection_adequacy?.length || 0 }}/5000
                              </small>
                              <div
                                v-if="vpartner.selection_adequacy.$error"
                                class="invalid-feedback"
                              >
                                <div v-if="!vpartner.selection_adequacy.required">
                                  {{ errorMessages.required }}
                                </div>
                              </div>
                            </div>
                            <b-alert show variant="warning">
                              Observaciones<br />
                              <ul>
                                <li>
                                  Para poder generar el 
                                  <strong>documento de autorización de centro colaborador</strong> 
                                  con los datos introducidos, primero debes seleccionar centro colaborador y añadir profesorado participante.
                                </li>
                                <li>
                                  En caso de no añadir profesorado participante, estos
                                  no estarán reflejados en el <strong>documento</strong>
                                </li>
                              </ul>
                            </b-alert>
                            <div class="form-inline mt-5">
                              <div class="form-group col-2">
                                <label for="file">Descargar Documento:</label>
                                <button
                                  id="btn-anexoI"
                                  @click.prevent="downloadFileAnexoICollaborator(center)"
                                  :disabled="!center.center_id"
                                  class="btn btn-info mr-4"
                                >
                                  <i class="fas fa-file-download mr-2"></i>
                                  Documento
                                </button>
                              </div>
                              <div class="form-group col-10">
                                <label for="filePartner"
                                  >Documento de aprobación del claustro y
                                  consejo escolar:
                                </label>
                                <div class="custom-file">
                                  <input
                                    id="inputFilePartner"
                                    type="file"
                                    name="filePartner"
                                    class="custom-file-input"
                                    @change="
                                      (event) =>
                                        onFilePartnerChange(event, center, i)
                                    "
                                    :class="{
                                      'is-invalid':
                                        vpartner.document_name.$error,
                                    }"
                                    accept="application/pdf"
                                  />
                                  <label
                                    class="custom-file-label"
                                    for="inputFilePartner"
                                    >{{ center?.document_name }}</label
                                  >
                                  <div
                                    v-if="vpartner.document_name.$error"
                                    class="invalid-feedback"
                                  >
                                    <div v-if="!vpartner.document_name.isPdf"
                                    >
                                      Solo se permiten archivos PDF.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                    <a
                      href="javascript:void(0);"
                      class="text-success"
                      @click="addRowCenterPartner()"
                    >
                      <i class="mdi mdi-plus-circle font-size-18"></i> Agregar
                      centro
                    </a>
                    <hr style="border-top: 5px solid rgb(0 0 0 / 10%)" />
                    <h4 class="card-title mt-4">
                      Empresas / Organismos colaboradores
                    </h4>
                    <b-card
                      no-body
                      class="mb-4 shadow-none mt-4"
                      v-for="(partner, i) in essay?.partner_companies"
                      :key="'partner-' + i"
                      :set="(vcompany = $v.essay.partner_companies.$each[i])"
                    >
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <h6
                          class="m-0 d-flex justify-content-between align-items-center"
                        >
                          <div class="form-inline">
                            <!-- <span>Empresa colaboradora {{ selectOptionsCenterPartners.find(item => item.id == center.center_id)?.name }}</span> -->
                            <span>Empresa colaboradora </span>
                          </div>
                          <div>
                            <b-icon
                              style="margin-right: 10px"
                              :icon="
                                collapseOpen[i] ? 'chevron-down' : 'chevron-up'
                              "
                              @click="toggleCollapse('partner-collapse-' + i)"
                              v-b-toggle="'partner-collapse-' + i"
                            ></b-icon>
                            <a
                              href="javascript:void(0);"
                              class="text-danger"
                              v-b-tooltip.hover
                              title="Eliminar"
                              @click="deleteRowPartner(i)"
                            >
                              <i class="mdi mdi-trash-can font-size-18"></i>
                            </a>
                          </div>
                        </h6>
                      </b-card-header>
                      <b-collapse
                        :id="'partner-collapse-' + i"
                        accordion="variation-accordion-partner"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <div class="row">
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <label for="name"
                                    >Nombre
                                    <span style="color: red">*</span></label
                                  >
                                  <input
                                    type="text"
                                    v-model="partner.name"
                                    class="form-control"
                                    id="name"
                                    placeholder="Nombre"
                                    maxlength="200"
                                    :class="{
                                      'is-invalid': vcompany.name.$error,
                                    }"
                                  />
                                  <div
                                    v-if="vcompany.name.$error"
                                    class="invalid-feedback"
                                  >
                                    <div v-if="!vcompany.name.required">
                                      {{ errorMessages.required }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <label for="partnerCIF"
                                    >CIF
                                    <span style="color: red">*</span></label
                                  >
                                  <input
                                    type="text"
                                    v-model="partner.cif"
                                    class="form-control"
                                    id="partnerCIF"
                                    placeholder="CIF"
                                    maxlength="10"
                                    :class="{
                                      'is-invalid': vcompany.cif.$error,
                                    }"
                                  />
                                  <div
                                    v-if="vcompany.cif.$error"
                                    class="invalid-feedback"
                                  >
                                    <div v-if="!vcompany.cif.required">
                                      {{ errorMessages.required }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <label for="partnerResponsable"
                                    >Responsable
                                    <span style="color: red">*</span></label
                                  >
                                  <input
                                    type="text"
                                    v-model="partner.responsable"
                                    class="form-control"
                                    id="partnerResponsable"
                                    maxlength="200"
                                    placeholder="Responsable"
                                    :class="{
                                      'is-invalid': vcompany.responsable.$error,
                                    }"
                                  />
                                  <div
                                    v-if="vcompany.responsable.$error"
                                    class="invalid-feedback"
                                  >
                                    <div v-if="!vcompany.responsable.required">
                                      {{ errorMessages.required }}
                                    </div>
                                    <div
                                      v-else-if="
                                        !vcompany.responsable.onlyLetters
                                      "
                                    >
                                      {{ errorMessages.onlyLetters }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="partnerEmail"
                                >Email <span style="color: red">*</span></label
                              >
                              <input
                                v-model="partner.email"
                                class="form-control"
                                id="partnerEmail"
                                placeholder="Email"
                                :class="{ 'is-invalid': vcompany.email.$error }"
                              />
                              <div
                                v-if="vcompany.email.$error"
                                class="invalid-feedback"
                              >
                                <div v-if="!vcompany.email.required">
                                  {{ errorMessages.required }}
                                </div>
                                <div v-else-if="!vcompany.email.email">
                                  {{ errorMessages.email }}
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="partnerAddress"
                                >Dirección
                                <span style="color: red">*</span></label
                              >
                              <input
                                v-model="partner.address"
                                class="form-control"
                                id="partnerAddress"
                                placeholder="Dirección"
                                maxlength="500"
                                :class="{
                                  'is-invalid': vcompany.address.$error,
                                }"
                              />
                              <div
                                v-if="vcompany.address.$error"
                                class="invalid-feedback"
                              >
                                <div v-if="!vcompany.address.required">
                                  {{ errorMessages.required }}
                                </div>
                              </div>
                            </div>
                            <div class="form-group mt-4">
                              <label for="selection_adequacy_partner_company">
                                IDONEIDAD DE LA ELECCIÓN
                                <span style="color: red">*</span>
                              </label>
                              <i
                                v-b-tooltip.hover
                                title="IDONEIDAD DE LA ELECCIÓN DE LOS PARTICIPANTES (CENTROS, EMPRESAS, ENTIDADES) QUE FORMAN PARTE DEL PROYECTO, VALORANDO LA APORTACIÓN DE CADA UNO DE ELLOS A LA MATERIALIZACIÓN DE LOS OBJETIVOS QUE SE PRETENDEN ALCANZAR."
                                class="far fa-question-circle font-size-12 ml-2"
                              ></i>
                              <app-textarea-ai
                                v-model="partner.selection_adequacy"
                                :enable-ai="true"
                                :max-chars="5000"
                                :rows="4"
                                placeholder="IDONEIDAD DE LA ELECCIÓN DE LOS PARTICIPANTES (CENTROS, EMPRESAS, ENTIDADES) QUE FORMAN PARTE DEL PROYECTO, VALORANDO LA APORTACIÓN DE CADA UNO DE ELLOS A LA MATERIALIZACIÓN DE LOS OBJETIVOS QUE SE PRETENDEN ALCANZAR."
                                :textarea-class="{
                                  'form-control': true,
                                  'is-invalid': vcompany.selection_adequacy.$error,
                                }"
                                id="selection_adequacy_partner_company"
                              ></app-textarea-ai>
                              <small class="text-muted">
                                {{ partner?.selection_adequacy?.length || 0 }}/5000
                              </small>
                              <div
                                v-if="vcompany.selection_adequacy.$error"
                                class="invalid-feedback"
                              >
                                <div v-if="!vcompany.selection_adequacy.required">
                                  {{ errorMessages.required }}
                                </div>
                              </div>
                            </div>
                            <b-alert show variant="warning">
                              Observaciones<br />
                              <ul>
                                <li>
                                  Para poder generar el
                                  <strong>Documento</strong> de empresas u
                                  organismos colaboradores, debes introducir sus
                                  datos en la tabla anterior.
                                </li>
                                <li>
                                  En caso de no añadir empresas u organismos
                                  colaboradores, estos no estarán reflejados en
                                  el <strong>Documento</strong>
                                </li>
                              </ul>
                            </b-alert>
                            <div class="form-inline mt-5">
                              <div class="form-group col-2">
                                <label for="file">Generar Documento:</label>
                                <button
                                  id="btn-anexoI"
                                  @click.prevent="
                                    downloadFileAnexoII(
                                      partner.name,
                                      partner.responsable,
                                      partner.cif
                                    )
                                  "
                                  class="btn btn-info mr-4"
                                >
                                  <i class="fas fa-file-download mr-2"></i>
                                  Documento
                                </button>
                              </div>
                              <div class="form-group col-10">
                                <label for="filePartnerCompany"
                                  >Carta de compromiso de participación de la
                                  empresa o entidad colaboradora:
                                </label>
                                <div class="custom-file">
                                  <input
                                    id="inputFilePartnerCompany"
                                    type="file"
                                    name="fileCompany"
                                    class="custom-file-input"
                                    @change="
                                      (event) =>
                                        onFilePartnerCompanyChange(
                                          event,
                                          partner,
                                          i
                                        )
                                    "
                                    :class="{
                                      'is-invalid':
                                        vcompany.document_name.$error,
                                    }"
                                    accept="application/pdf"
                                  />
                                  <label
                                    class="custom-file-label"
                                    for="inputFilePartnerCompany"
                                    >{{ partner?.document_name }}</label
                                  >
                                  <div
                                    v-if="vcompany.document_name.$error"
                                    class="invalid-feedback"
                                  >
                                    <div
                                      v-if="!vcompany.document_name.isPdf"
                                    >
                                      Solo se permiten archivos PDF.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                    <a
                      href="javascript:void(0);"
                      class="text-success"
                      @click="addRowPartner()"
                    >
                      <i class="mdi mdi-plus-circle font-size-18"></i> Agregar
                      empresa / organismo
                    </a>
                  </div>
                </tab-content>
                <tab-content title="Acciones e Indicadores de realización">
                  <div class="tab-pane" id="metadata">
                    <div class="form-group">
                      <label for="projectPhases">
                        Fases del proyecto
                        <span style="color: red">*</span>
                      </label>
                      <app-textarea-ai
                        v-model="essay.project_phases"
                        :enable-ai="true"
                        :max-chars="5000"
                        :rows="4"
                        placeholder="Fases del proyecto"
                        :textarea-class="{
                          'form-control': true,
                          'is-invalid': $v.essay.project_phases.$error,
                        }"
                        id="projectPhases"
                      ></app-textarea-ai>
                      <small class="text-muted">
                        {{ essay?.project_phases?.length || 0 }}/5000
                      </small>
                      <div
                        v-if="$v.essay.project_phases.$error"
                        class="invalid-feedback"
                      >
                        <div v-if="!$v.essay.project_phases.required">
                          {{ errorMessages.required }}
                        </div>
                      </div>
                    </div>
                    <h4 class="card-title">
                      Planificación de acciones
                      <i
                        v-b-tooltip.hover
                        title="DESCRIPCIÓN GENERAL DE LAS ACCIONES PLANIFICADAS, CON INDICACIÓN DE LAS QUE ASUME CADA PARTICIPANTE EN EL PROYECTO (CENTROS EDUCATIVOS Y EMPRESAS O ENTIDADES)."
                        class="far fa-question-circle font-size-12 ml-2"
                      ></i>
                    </h4>
                    <b-card
                      no-body
                      class="mb-1 shadow-none mt-4"
                      v-for="(action, i) in essay.actions"
                      :key="i"
                      :set="(vaction = $v.essay.actions.$each[i])"
                    >
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <h6
                          class="m-0 d-flex justify-content-between align-items-center"
                        >
                          <div class="form-inline">
                            <span>Acción: {{ action.name }}</span>
                          </div>
                          <div>
                            <b-icon
                              style="margin-right: 10px"
                              :icon="
                                collapseOpen[i] ? 'chevron-down' : 'chevron-up'
                              "
                              @click="toggleCollapse('collapse-' + i)"
                              v-b-toggle="'collapse-' + i"
                            ></b-icon>
                            <a
                              href="javascript:void(0);"
                              class="text-danger"
                              v-b-tooltip.hover
                              title="Eliminar"
                              @click="deleteRowAction(i)"
                            >
                              <i class="mdi mdi-trash-can font-size-18"></i>
                            </a>
                          </div>
                        </h6>
                      </b-card-header>
                      <b-collapse
                        :id="'collapse-' + i"
                        accordion="variation-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <div class="row">
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <label for="name"
                                    >Nombre
                                    <span style="color: red">*</span></label
                                  >
                                  <input
                                    type="text"
                                    v-model="action.name"
                                    class="form-control"
                                    id="name"
                                    placeholder="Nombre"
                                    maxlength="200"
                                    :class="{
                                      'is-invalid': vaction.name.$error,
                                    }"
                                  />
                                  <small class="text-muted"
                                    >{{ action?.name?.length }}/200</small
                                  >
                                  <div
                                    v-if="$v.essay.actions.$each[i].name.$error"
                                    class="invalid-feedback"
                                  >
                                    <div
                                      v-if="
                                        !$v.essay.actions.$each[i].name.required
                                      "
                                    >
                                      {{ errorMessages.required }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <label for="initDate"
                                    >Ejecución inicial
                                    <span style="color: red">*</span></label
                                  >
                                  <!-- <input type="date" :value="formatDate(action.init_date)" @input="updateDate($event, i, 'init_date')" id="initDate" class="form-control" placeholder="Ejecución inicial" :class="{ 'is-invalid': vaction.init_date.$error }"/> -->
                                  <input
                                    type="date"
                                    v-model="action.init_date"
                                    id="initDate"
                                    class="form-control"
                                    placeholder="Ejecución inicial"
                                    :class="{
                                      'is-invalid': vaction.init_date.$error,
                                    }"
                                  />
                                  <div
                                    v-if="vaction.init_date.$error"
                                    class="invalid-feedback"
                                  >
                                    <div v-if="!vaction.init_date.required">
                                      Este campo es obligatorio o incorrecto
                                    </div>
                                    <div
                                      v-else-if="
                                        !vaction.init_date.validDateFormat
                                      "
                                    >
                                      Introduce una fecha valida
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <label for="endDate"
                                    >Ejecución final
                                    <span style="color: red">*</span></label
                                  >
                                  <!-- <input type="date" :value="formatDate(action.end_date)" @input="updateDate($event, i, 'end_date'); validateEndDate(i)" id="endDate" class="form-control" placeholder="Ejecución final" :class="{ 'is-invalid': vaction.end_date.$error }"/> -->
                                  <input
                                    type="date"
                                    v-model="action.end_date"
                                    id="endDate"
                                    class="form-control"
                                    placeholder="Ejecución final"
                                    :class="{
                                      'is-invalid': vaction.end_date.$error,
                                    }"
                                  />
                                  <div
                                    v-if="vaction.end_date.$error"
                                    class="invalid-feedback"
                                  >
                                    <div v-if="!vaction.end_date.required">
                                      Este campo es obligatorio o incorrecto
                                    </div>
                                    <div
                                      v-else-if="
                                        !vaction.end_date.validDateFormat
                                      "
                                    >
                                      Introduce una fecha valida
                                    </div>
                                    <div
                                      v-else-if="!vaction.end_date.validEndDate"
                                    >
                                      La ejecución final no puede ser menor que
                                      la inicial
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label for="descriptionAction"
                                >Descripción
                                <span style="color: red">*</span></label
                              ><i
                                v-b-tooltip.hover
                                title="Describe en que consiste la acción, que centros, departamentos y empresas van a participar"
                                class="far fa-question-circle font-size-12 ml-2"
                              ></i>
                              <app-textarea-ai
                                v-model="action.descriptions"
                                :enable-ai="true"
                                :max-chars="5000"
                                :rows="3"
                                placeholder="Describe en que consiste la acción, que centros, departamentos y empresas van a participar"
                                :textarea-class="{
                                  'form-control': true,
                                  'is-invalid': vaction.descriptions.$error,
                                }"
                                id="descriptionAction"
                              ></app-textarea-ai>
                              <small class="text-muted"
                                >{{ action?.descriptions?.length }}/5000</small
                              >
                              <div
                                v-if="vaction.name.$error"
                                class="invalid-feedback"
                              >
                                <div v-if="!vaction.name.required">
                                  {{ errorMessages.required }}
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-12">
                                <div class="form-group">
                                  <label for="actionResponsable"
                                    >Persona responsable
                                    <span style="color: red">*</span></label
                                  ><i
                                    v-b-tooltip.hover
                                    title="Nombre de la persona o personas responsables de coordinar y gestionar la acción"
                                    class="far fa-question-circle font-size-12 ml-2"
                                  ></i>
                                  <input
                                    type="text"
                                    v-model="action.responsables"
                                    id="actionResponsable"
                                    class="form-control"
                                    maxlength="200"
                                    placeholder="Persona responsable"
                                    :class="{
                                      'is-invalid': vaction.responsables.$error,
                                    }"
                                  />
                                  <div
                                    v-if="vaction.responsables.$error"
                                    class="invalid-feedback"
                                  >
                                    <div v-if="!vaction.responsables.required">
                                      {{ errorMessages.required }}
                                    </div>
                                    <div
                                      v-else-if="
                                        !vaction.responsables.onlyLetters
                                      "
                                    >
                                      {{ errorMessages.onlyLetters }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-12">
                                <div class="form-group">
                                  <label
                                    >Centro / Empresa Responsable
                                    <span style="color: red">*</span></label
                                  ><i
                                    v-b-tooltip.hover
                                    title="Centro educativo o empresa responsable de coordinar y gestionar la acción"
                                    class="far fa-question-circle font-size-12 ml-2"
                                  ></i>
                                  <div class="d-flex flex-wrap mb-2">
                                    <b-form-radio
                                      :checked="getResponsibleGroup(action)"
                                      value="center"
                                      class="mr-4"
                                      @change="setResponsibleGroup(action, 'center')"
                                    >
                                      Centro
                                    </b-form-radio>
                                    <b-form-radio
                                      :checked="getResponsibleGroup(action)"
                                      value="company"
                                      @change="setResponsibleGroup(action, 'company')"
                                    >
                                      Empresa
                                    </b-form-radio>
                                  </div>
                                  <select
                                    v-if="getResponsibleGroup(action) === 'center'"
                                    class="form-control"
                                    :value="getResponsibleSelectValue(action)"
                                    :class="{
                                      'is-invalid':
                                        vaction.responsible_id?.$error ||
                                        vaction.responsible_type?.$error,
                                    }"
                                    @change="setResponsibleSelectValue(action, $event.target.value)"
                                  >
                                    <option value="">Selecciona un centro</option>
                                    <option
                                      v-for="option in actionCenterOptions"
                                      :key="option.value"
                                      :value="option.value"
                                    >
                                      {{ option.name }}
                                    </option>
                                  </select>
                                  <select
                                    v-else-if="getResponsibleGroup(action) === 'company'"
                                    class="form-control"
                                    :value="getResponsibleSelectValue(action)"
                                    :class="{
                                      'is-invalid':
                                        vaction.responsible_id?.$error ||
                                        vaction.responsible_type?.$error,
                                    }"
                                    @change="setResponsibleSelectValue(action, $event.target.value)"
                                  >
                                    <option value="">Selecciona una empresa</option>
                                    <option
                                      v-for="option in actionCompanyOptions"
                                      :key="option.value"
                                      :value="option.value"
                                    >
                                      {{ option.name }}
                                    </option>
                                  </select>
                                  <div
                                    v-if="
                                      vaction.responsible_id?.$error ||
                                      vaction.responsible_type?.$error
                                    "
                                    class="invalid-feedback d-block"
                                  >
                                    <div
                                      v-if="
                                        !vaction.responsible_type?.required ||
                                        !vaction.responsible_id?.required
                                      "
                                    >
                                      {{ errorMessages.required }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-12">
                                <div class="form-group">
                                  <label for="actionRisks"
                                    >Riesgos
                                    <span style="color: red">*</span></label
                                  ><i
                                    v-b-tooltip.hover
                                    title="En caso de no existir riesgos reseñables, indicar 'La acción se podrá desarrollar'. en caso de posibles riesgos, indicarlos y describirlos"
                                    class="far fa-question-circle font-size-12 ml-2"
                                  ></i>
                                  <app-textarea-ai
                                    v-model="action.risks"
                                    :enable-ai="true"
                                    :max-chars="5000"
                                    :rows="3"
                                    placeholder="En caso de no existir riesgos reseñables, indicar 'La acción se podrá desarrollar'. en caso de posibles riesgos, indicarlos y describirlos"
                                    :textarea-class="{
                                      'form-control': true,
                                      'is-invalid': vaction.risks.$error,
                                    }"
                                    id="actionRisks"
                                  ></app-textarea-ai>
                                  <small class="text-muted"
                                    >{{ action?.risks?.length }}/5000</small
                                  >
                                  <div
                                    v-if="vaction.risks.$error"
                                    class="invalid-feedback"
                                  >
                                    <div v-if="!vaction.risks.required">
                                      {{ errorMessages.required }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-lg-12">
                                <div class="form-group">
                                  <label for="actionPlan"
                                    >Plan de contingencia
                                    <span style="color: red">*</span></label
                                  ><i
                                    v-b-tooltip.hover
                                    title="Cuando existan riesgos, definir el plan a aplicar. En caso contrario, indicar 'No aplica'"
                                    class="far fa-question-circle font-size-12 ml-2"
                                  ></i>
                                  <app-textarea-ai
                                    v-model="action.contingency_plan"
                                    :enable-ai="true"
                                    :max-chars="5000"
                                    :rows="3"
                                    placeholder="Cuando existan riesgos, definir el plan a aplicar. En caso contrario, indicar 'No aplica'"
                                    :textarea-class="{
                                      'form-control': true,
                                      'is-invalid':
                                        vaction.contingency_plan.$error,
                                    }"
                                    id="actionPlan"
                                  ></app-textarea-ai>
                                  <small class="text-muted"
                                    >{{
                                      action?.contingency_plan?.length
                                    }}/5000</small
                                  >
                                  <div
                                    v-if="vaction.contingency_plan.$error"
                                    class="invalid-feedback"
                                  >
                                    <div
                                      v-if="!vaction.contingency_plan.required"
                                    >
                                      {{ errorMessages.required }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <label for="file">Actividades educativas</label>
                            <table
                              class="table table-bordered table-sticky-header"
                            >
                              <thead>
                                <tr>
                                  <th scope="col">
                                    Nombre
                                    <i
                                      v-b-tooltip.hover
                                      title="Título de la actividad a realizar"
                                      class="far fa-question-circle font-size-12 ml-2"
                                    ></i>
                                  </th>
                                  <th scope="col">
                                    Metodología
                                    <i
                                      v-b-tooltip.hover
                                      title="Breve descripción de la actividad y que metodología didáctica se usará para llevarla a cabo"
                                      class="far fa-question-circle font-size-12 ml-2"
                                    ></i>
                                  </th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(
                                    activity, j
                                  ) in action.education_activities"
                                  :key="j"
                                  class=""
                                  :set="
                                    (vactivity =
                                      vaction.education_activities.$each[j])
                                  "
                                >
                                  <td>
                                    <div class="form-group">
                                      <input
                                        type="text"
                                        v-model="activity.name"
                                        class="form-control"
                                        placeholder="Nombre"
                                        maxlength="200"
                                        :class="{
                                          'is-invalid': vactivity.name.$error,
                                        }"
                                      />
                                      <small class="text-muted"
                                        >{{ activity?.name?.length }}/200</small
                                      >
                                      <div
                                        v-if="vactivity.name.$error"
                                        class="invalid-feedback"
                                      >
                                        <div v-if="!vactivity.name.required">
                                          {{ errorMessages.required }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="form-group">
                                      <app-textarea-ai
                                        v-model="activity.methodology"
                                        :enable-ai="true"
                                        :max-chars="1000"
                                        :rows="3"
                                        placeholder="Metodología"
                                        :textarea-class="{
                                          'form-control': true,
                                          'is-invalid':
                                            vactivity.methodology.$error,
                                        }"
                                        :id="`methodology-${i}-${j}`"
                                      ></app-textarea-ai>
                                      <small class="text-muted"
                                        >{{
                                          activity?.methodology?.length || 0
                                        }}/1000</small
                                      >
                                      <div
                                        v-if="vactivity.methodology.$error"
                                        class="invalid-feedback"
                                      >
                                        <div
                                          v-if="!vactivity.methodology.required"
                                        >
                                          {{ errorMessages.required }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td class="text-center">
                                    <a
                                      href="javascript:void(0);"
                                      class="text-danger"
                                      v-b-tooltip.hover
                                      title="Eliminar"
                                      @click="deleteRowActionActivity(i, j)"
                                    >
                                      <i
                                        class="mdi mdi-trash-can font-size-18"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td colspan="8" class="text-right">
                                    <a
                                      href="javascript:void(0);"
                                      class="text-success"
                                      @click="addRowActivity(action)"
                                    >
                                      <i
                                        class="mdi mdi-plus-circle font-size-18"
                                      ></i>
                                      Agregar actividad
                                    </a>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                            <label for="file">Previsión económica</label>
                            <table
                              class="table table-bordered table-sticky-header"
                            >
                              <thead>
                                <tr>
                                  <th scope="col">
                                    Material <span style="color: red">*</span>
                                  </th>
                                  <th scope="col">
                                    Coste (€) <span style="color: red">*</span>
                                  </th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(
                                    forecast, k
                                  ) in action.economic_forecats"
                                  :key="k"
                                  class=""
                                  :set="
                                    (vforecast =
                                      vaction.economic_forecats.$each[k])
                                  "
                                >
                                  <td>
                                    <div class="form-group">
                                      <input
                                        type="text"
                                        v-model="forecast.material"
                                        class="form-control"
                                        placeholder="Material"
                                        maxlength="200"
                                        :class="{
                                          'is-invalid':
                                            vforecast.material.$error,
                                        }"
                                      />
                                      <small class="text-muted"
                                        >{{
                                          forecast?.material?.length
                                        }}/200</small
                                      >
                                      <div
                                        v-if="vforecast.material.$error"
                                        class="invalid-feedback"
                                      >
                                        <div
                                          v-if="!vforecast.material.required"
                                        >
                                          {{ errorMessages.required }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="form-group">
                                      <input
                                        type="text"
                                        v-model="forecast.cost"
                                        class="form-control"
                                        placeholder="Coste (€)"
                                        maxlength="20"
                                        :class="{
                                          'is-invalid':
                                            vforecast.cost.$invalid &&
                                            vforecast.cost.$dirty,
                                        }"
                                      />
                                      <div
                                        v-if="vforecast.cost.$dirty"
                                        class="invalid-feedback"
                                      >
                                        <span v-if="!vforecast.cost.required">
                                          Este campo es requerido
                                        </span>
                                        <span
                                          v-if="
                                            !vforecast.cost
                                              .noCommasOrApostrophes
                                          "
                                        >
                                          El separador de decimales debe ser el
                                          punto (.).
                                        </span>
                                        <span
                                          v-else-if="
                                            !vforecast.cost.noInvalidCharacters
                                          "
                                        >
                                          Solo se permiten valores numéricos.
                                        </span>
                                        <span
                                          v-else-if="
                                            !vforecast.cost.validDecimal
                                          "
                                        >
                                          Introduce un número válido.
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td class="text-center">
                                    <a
                                      href="javascript:void(0);"
                                      class="text-danger"
                                      v-b-tooltip.hover
                                      title="Eliminar"
                                      @click="deleteRowActionForecast(i, k)"
                                    >
                                      <i
                                        class="mdi mdi-trash-can font-size-18"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td colspan="8" class="text-right">
                                    <a
                                      href="javascript:void(0);"
                                      class="text-success"
                                      @click="addRowForecast(action)"
                                    >
                                      <i
                                        class="mdi mdi-plus-circle font-size-18"
                                      ></i>
                                      Agregar previsión
                                    </a>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                    <a
                      href="javascript:void(0);"
                      class="text-success"
                      @click="addRowAction()"
                    >
                      <i class="mdi mdi-plus-circle font-size-18"></i> Agregar
                      acción
                    </a>
                    <h4 class="card-title mt-5">
                      Indicador de realización de objetivos
                    </h4>
                    <b-card
                      no-body
                      class="mb-1 shadow-none mt-4"
                      v-for="(target, i) in essay.targets"
                      :key="'target-' + i"
                    >
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <h6
                          class="m-0 d-flex justify-content-between align-items-center"
                        >
                          <div class="form-inline">
                            <span>Objetivo: {{ target.title }}</span>
                          </div>
                          <div>
                            <b-icon
                              style="margin-right: 10px"
                              :icon="
                                collapseOpen[i] ? 'chevron-down' : 'chevron-up'
                              "
                              @click="toggleCollapse('target-collapse-' + i)"
                              v-b-toggle="'target-collapse-' + i"
                            ></b-icon>
                          </div>
                        </h6>
                      </b-card-header>
                      <b-collapse
                        :id="'target-collapse-' + i"
                        accordion="variation-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-card-text>
                            <label for="file"
                              >Indicador de realización de objetivos</label
                            >
                            <table
                              class="table table-bordered table-sticky-header"
                            >
                              <thead>
                                <tr>
                                  <th scope="col">
                                    Nombre <span style="color: red">*</span>
                                  </th>
                                  <th scope="col">
                                    Descripción
                                    <span style="color: red">*</span>
                                  </th>
                                  <th scope="col">
                                    Valores de medida
                                    <span style="color: red">*</span>
                                  </th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(
                                    achievement, j
                                  ) in target.target_achievements"
                                  :key="'archievement-' + j"
                                  class=""
                                  :set="
                                    (vindicador =
                                      $v.essay.targets.$each[i]
                                        .target_achievements.$each[j])
                                  "
                                >
                                  <td>
                                    <div class="form-group">
                                      <input
                                        type="text"
                                        v-model="achievement.name"
                                        class="form-control"
                                        placeholder="Nombre"
                                        maxlength="200"
                                        :class="{
                                          'is-invalid': vindicador.name.$error,
                                        }"
                                      />
                                      <small class="text-muted"
                                        >{{
                                          achievement?.name?.length
                                        }}/200</small
                                      >
                                      <div
                                        v-if="vindicador.name.$error"
                                        class="invalid-feedback"
                                      >
                                        <div v-if="!vindicador.name.required">
                                          {{ errorMessages.required }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="form-group">
                                      <app-textarea-ai
                                        v-model="achievement.description"
                                        :enable-ai="true"
                                        :max-chars="5000"
                                        :rows="4"
                                        placeholder="Descripción"
                                        :textarea-class="{
                                          'form-control': true,
                                          'is-invalid':
                                            vindicador.description.$error,
                                        }"
                                      ></app-textarea-ai>
                                      <small class="text-muted"
                                        >{{
                                          achievement?.description?.length
                                        }}/5000</small
                                      >
                                      <div
                                        v-if="vindicador.description.$error"
                                        class="invalid-feedback"
                                      >
                                        <div
                                          v-if="
                                            !vindicador.description.required
                                          "
                                        >
                                          {{ errorMessages.required }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="form-group">
                                      <app-textarea-ai
                                        v-model="achievement.measured_values"
                                        :enable-ai="true"
                                        :max-chars="5000"
                                        :rows="4"
                                        placeholder="Valores de medida"
                                        :textarea-class="{
                                          'form-control': true,
                                          'is-invalid':
                                            vindicador.measured_values.$error,
                                        }"
                                      ></app-textarea-ai>
                                      <small class="text-muted"
                                        >{{
                                          achievement?.measured_values?.length
                                        }}/5000</small
                                      >
                                      <div
                                        v-if="vindicador.measured_values.$error"
                                        class="invalid-feedback"
                                      >
                                        <div
                                          v-if="
                                            !vindicador.measured_values.required
                                          "
                                        >
                                          {{ errorMessages.required }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td class="text-center">
                                    <a
                                      href="javascript:void(0);"
                                      class="text-danger"
                                      v-b-tooltip.hover
                                      title="Eliminar"
                                      @click="deleteRowTargetAchievement(i, j)"
                                    >
                                      <i
                                        class="mdi mdi-trash-can font-size-18"
                                      ></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td colspan="8" class="text-right">
                                    <a
                                      href="javascript:void(0);"
                                      class="text-success"
                                      @click="addRowAchievement(target)"
                                    >
                                      <i
                                        class="mdi mdi-plus-circle font-size-18"
                                      ></i>
                                      Agregar indicador
                                    </a>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </b-card-text>
                          <b-card-text>
                            <label for="file"
                              >Indicador de realización de resultados</label
                            >
                            <b-card
                              no-body
                              class="mb-1 shadow-none mt-4"
                              v-for="(result, k) in target.target_results"
                              :key="'result-' + k"
                              :set="
                                (vr =
                                  $v.essay.targets.$each[i].target_results
                                    .$each[k])
                              "
                            >
                              <b-card-header
                                header-tag="header"
                                class="p-1"
                                role="tab"
                              >
                                <h6
                                  class="m-0 d-flex justify-content-between align-items-center"
                                >
                                  <div class="form-inline">
                                    <span>Resultado: {{ result.title }}</span>
                                  </div>
                                  <div>
                                    <b-icon
                                      style="margin-right: 10px"
                                      :icon="
                                        collapseOpen['result-collapse-' + k]
                                          ? 'chevron-down'
                                          : 'chevron-up'
                                      "
                                      @click="
                                        toggleCollapse('result-collapse-' + k)
                                      "
                                      v-b-toggle="'result-collapse-' + k"
                                    ></b-icon>
                                  </div>
                                </h6>
                              </b-card-header>
                              <b-collapse
                                :id="'result-collapse-' + k"
                                accordion="variation-accordion-result"
                                role="tabpanel"
                              >
                                <b-card-body>
                                  <b-card-text>
                                    <table
                                      class="table table-bordered table-sticky-header"
                                    >
                                      <thead>
                                        <tr>
                                          <th scope="col">
                                            Nombre
                                            <span style="color: red">*</span>
                                          </th>
                                          <th scope="col">
                                            Descripción
                                            <span style="color: red">*</span>
                                          </th>
                                          <th scope="col">
                                            Valores de medida
                                            <span style="color: red">*</span>
                                          </th>
                                          <th></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          v-for="(
                                            result_achievement, l
                                          ) in result.result_achievements"
                                          :key="'result-archievement-' + l"
                                          class=""
                                          :set="
                                            (vrindicador =
                                              vr.result_achievements.$each[l])
                                          "
                                        >
                                          <td>
                                            <div class="form-group">
                                              <input
                                                type="text"
                                                v-model="
                                                  result_achievement.name
                                                "
                                                class="form-control"
                                                placeholder="Nombre"
                                                maxlength="200"
                                                :class="{
                                                  'is-invalid':
                                                    vrindicador.name.$error,
                                                }"
                                              />
                                              <small class="text-muted"
                                                >{{
                                                  result_achievement?.name
                                                    ?.length
                                                }}/200</small
                                              >
                                              <div
                                                v-if="vrindicador.name.$error"
                                                class="invalid-feedback"
                                              >
                                                <div
                                                  v-if="
                                                    !vrindicador.name.required
                                                  "
                                                >
                                                  {{ errorMessages.required }}
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <div class="form-group">
                                              <app-textarea-ai
                                                v-model="
                                                  result_achievement.description
                                                "
                                                :enable-ai="true"
                                                :max-chars="5000"
                                                :rows="4"
                                                placeholder="Descripción"
                                                :textarea-class="{
                                                  'form-control': true,
                                                  'is-invalid':
                                                    vrindicador.description
                                                      .$error,
                                                }"
                                              ></app-textarea-ai>
                                              <small class="text-muted"
                                                >{{
                                                  result_achievement
                                                    ?.description?.length
                                                }}/5000</small
                                              >
                                              <div
                                                v-if="
                                                  vrindicador.description.$error
                                                "
                                                class="invalid-feedback"
                                              >
                                                <div
                                                  v-if="
                                                    !vrindicador.description
                                                      .required
                                                  "
                                                >
                                                  {{ errorMessages.required }}
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <div class="form-group">
                                              <app-textarea-ai
                                                v-model="
                                                  result_achievement.measured_values
                                                "
                                                :enable-ai="true"
                                                :max-chars="5000"
                                                :rows="4"
                                                placeholder="Valores de medida"
                                                :textarea-class="{
                                                  'form-control': true,
                                                  'is-invalid':
                                                    vrindicador.measured_values
                                                      .$error,
                                                }"
                                              ></app-textarea-ai>
                                              <small class="text-muted"
                                                >{{
                                                  result_achievement
                                                    ?.measured_values?.length
                                                }}/5000</small
                                              >
                                              <div
                                                v-if="
                                                  vrindicador.measured_values
                                                    .$error
                                                "
                                                class="invalid-feedback"
                                              >
                                                <div
                                                  v-if="
                                                    !vrindicador.measured_values
                                                      .required
                                                  "
                                                >
                                                  {{ errorMessages.required }}
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                          <td class="text-center">
                                            <a
                                              href="javascript:void(0);"
                                              class="text-danger"
                                              v-b-tooltip.hover
                                              title="Eliminar"
                                              @click="
                                                deleteRowResultAchievement(
                                                  i,
                                                  k,
                                                  l
                                                )
                                              "
                                            >
                                              <i
                                                class="mdi mdi-trash-can font-size-18"
                                              ></i>
                                            </a>
                                          </td>
                                        </tr>
                                      </tbody>
                                      <tfoot>
                                        <tr>
                                          <td colspan="8" class="text-right">
                                            <a
                                              href="javascript:void(0);"
                                              class="text-success"
                                              @click="
                                                addRowResultAchievement(result)
                                              "
                                            >
                                              <i
                                                class="mdi mdi-plus-circle font-size-18"
                                              ></i>
                                              Agregar indicador
                                            </a>
                                          </td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                  </b-card-text>
                                </b-card-body>
                              </b-collapse>
                            </b-card>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </tab-content>
                <template slot="prev" slot-scope="props">
                  <wizard-button
                    :disabled="globalLoading"
                    @click.native="draftAction = false"
                    class="wizard-footer-left"
                    :style="props.fillButtonStyle"
                    >Volver</wizard-button
                  >
                </template>
                <template slot="next" slot-scope="props">
                  <wizard-button
                    :disabled="globalLoading"
                    @click.native.prevent="handleSave"
                    class="wizard-footer-left mr-2"
                    style="
                      color: #fff;
                      background-color: #1cbb8c;
                      border-color: #1cbb8c;
                    "
                    >Guardar</wizard-button
                  >
                  <wizard-button
                    :disabled="globalLoading"
                    @click.native="draftAction = false"
                    class="wizard-footer-right"
                    :style="props.fillButtonStyle"
                    >Guardar y continuar</wizard-button
                  >
                </template>
                <template slot="finish" slot-scope="props">
                  <wizard-button
                    :disabled="globalLoading || ending"
                    @click.native="saveFinishStep"
                    class="wizard-footer-left mr-2"
                    style="
                      color: #fff;
                      background-color: #1cbb8c;
                      border-color: #1cbb8c;
                    "
                    >Guardar</wizard-button
                  >
                  <wizard-button
                    :disabled="globalLoading || loading"
                    @click.native="finishStep"
                    class="wizard-footer-right finish-button"
                    :style="props.fillButtonStyle"
                    ><span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      v-if="ending"
                    ></span>
                    {{ ending ? "Finalizando..." : "Finalizar" }}</wizard-button
                  >
                </template>
              </form-wizard>
              <b-alert v-if="ending" show>
                <b-icon
                  icon="exclamation-circle-fill"
                  class="mr-2"
                  variant="info"
                ></b-icon>
                Se está generando la memoria del proyecto. Espere un momento...
              </b-alert>
            </div>
          </div>
        </div>
      </div>
    </template>
    </b-modal>
  </div>
</template>
<style>
.progress-bar {
  width: 100%;
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
}

.progress {
  height: 100%;
  background-color: #76c7c0;
  transition: width 0.2s;
}

/* Styles for multiselect validation errors */
.is-invalid .multiselect .multiselect__tags {
  border-color: #dc3545 !important;
  border-width: 1px;
}

.is-invalid .multiselect .multiselect__tags:focus-within {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.multiselect--invalid .multiselect__tags {
  border-color: #dc3545 !important;
  border-width: 1px;
}

.multiselect--invalid .multiselect__tags:focus-within {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}
</style>
